let STORE = STORE || {};

(()=> {

	// STORE.CONS.MARUI_DOMAIN = 'https://www.0101.co.jp';
	STORE.CONS.MARUI_DOMAIN = location.hostname.match(/^(www|www-origin)\.0101\.co\.jp/) ? 'https://www.0101.co.jp' : 'https://stg.0101.co.jp';
	STORE.CONS.MARUI_DEV_DOMAIN = 'https://dev.0101.co.jp';
	STORE.CONS.PROD_DOMAINS = [
		'www.0101.co.jp',
		'www.0101.co.jp.e.ex.hp.transer.com',
		'www.0101.co.jp.t.ex.hp.transer.com',
		'www.0101.co.jp.c.ex.hp.transer.com',
		'www.0101.co.jp.k.ex.hp.transer.com',
		'www-origin.0101.co.jp',
		'stg.0101.co.jp',
		// 'dev.0101.co.jp', // ローカル検証用
		// 'localhost' // ローカル検証用
  ];
	STORE.CONS.DEV_DOMAINS = [
		'dev.0101.co.jp'
	];

	STORE.CONS.SHOP_MAIL_DOMAIN = 'https://web.0101.co.jp/xml/shopmail/00${stcd}.xml';

  STORE.CONS.STORE_CODES = {
    '086' : '有楽町マルイ',
		'003' : '新宿マルイ 本館',
		'005' : '新宿マルイ アネックス',
		'074' : '新宿マルイ メン',
		'013' : '渋谷マルイ',
		'058' : '上野マルイ',
		'054' : '錦糸町マルイ',
		'001' : '中野マルイ',
		'016' : '吉祥寺マルイ',
		'062' : '国分寺マルイ',
		'052' : '町田マルイ',
		'077' : 'マルイシティ横浜',
		'082' : '海老名マルイ',
		'076' : '柏マルイ',
		'084' : '北千住マルイ',
		'078' : 'マルイファミリー溝口',
		'053' : '大宮マルイ',
		'079' : 'マルイファミリー志木',
		'066' : '草加マルイ',
		'085' : 'なんばマルイ',
		'083' : '神戸マルイ',
		'060' : '戸塚モディ(まるい食遊館戸塚店)',
		'090' : '博多マルイ',
		'722' : '柏モディ',
		'723' : '町田モディ',
		'724' : '静岡モディ',
		'721' : '渋谷モディ',
		'999' : 'テスト店舗'
  };

	STORE.CONS.CHANGE_STORE_NAME = {
		"016" : '吉祥寺マルイ',
		"054" : '錦糸町マルイ'
	};

  STORE.CONS.STORE_CODES_EN = {
	'086' : 'YURAKUCHO MARUI',
	'003' : 'SHINJUKU MARUI HONKAN',
	'005' : 'SHINJUKU MARUI ANEX',
	'074' : 'SHINJUKU MARUI MEN',
	'013' : 'SHIBUYA MARUI',
	'058' : 'UENO MARUI',
	'054' : 'KINSHICHO MARUI',
	'001' : 'NAKANO MARUI',
	'016' : 'KICHIJOJI MARUI',
	'062' : 'KOKUBUNJI MARUI',
	'052' : 'MACHIDA MARUI',
	'077' : 'MARUI CITY YOKOHAMA',
	'082' : 'EBINA MARUI',
	'076' : 'KASHIWA MARUI',
	'084' : 'KITASENJU MARUI',
	'078' : 'MARUI FAMILY MIZONOKUCHI',
	'053' : 'OMIYA MARUI',
	'079' : 'MARUI FAMILY SHIKI',
	'066' : 'SOKA MARUI',
	'085' : 'NAMBA MARUI',
	'083' : 'KOBE MARUI',
	'060' : 'TOTSUKA MODI',
	'090' : 'HAKATA MARUI',
	'722' : 'KASHIWA MODI',
	'723' : 'MACHIDA MODI',
	'724' : 'SHIZUOKA MODI',
	'721' : 'SHIBUYA MODI',
	'999' : 'TEST STORE'
  }

  	STORE.CONS.CHANGE_STORE_NAME_EN = {
		"016" : 'KICHIJOJI MARUI',
		"054" : 'KINSHICHO MARUI'
	};

  STORE.CONS.TTS_FILES = {
    'ANNOUNCE'      : '/contents2/announce/${stcd}/emgncy_announce_list.json',
		'BANNER'        : '/contents2/banner/${stcd}/banner_list.json',
		'CAMPAIGN'      : '/contents2/campaign/${stcd}/campaign_list.json',
		'COUPON'        : '/contents2/coupon/${stcd}/coupon_list.json',
		'FACILITY_INFO' : '/contents2/facilityinfo/${stcd}/facility.json',
		'FEATURE'       : '/contents2/feature/${stcd}/feature_article_list.json',
		'FLOOR'         : '/contents2/floormap/${stcd}/floor_map_list.json',
		'SHOP_LIST'     : '/contents2/shopinfo/${stcd}/shop_list.json',
		'SHOP_INTRO'    : '/contents2/shopinfo/${stcd}/shop_introduce_list.json',
		'SHOP_NEWS'     : '/contents2/shopnews/${stcd}/shop_article_list.json',
		'STORE_NEWS'    : '/contents2/storenews/${stcd}/store_article_list.json',
  };

  STORE.CONS.DEBUG_TTS_PATH = '/marui-utils/xml-load/?url=';
  //STORE.CONS.DEBUG_TTS_PATH = '';	// ローカル参照テスト用（この行を削除して上の行のコメントアウトを外すと本番参照に戻ります）
  //STORE.CONS.DEBUG_SHOP_MAIL_PATH = '/marui-utils/xml-load/?url=';

  /** 画像種別 (STORE.UTIL.imgDataPath の第2引数で使用) */
  STORE.CONS.IMG_TYPE = {
    ORIGIN : '',
    AUTO   : 'auto',      // 自動（スマホはwebp中、それ以外はwebp大)
    JPG    : '.jpg',      // JPG
    WEBP_M : '_m.webp',   // 中サイズ webp
    WEBP_L : '_l.webp'    // 大サイズ webp
  };

  // STORE.CONS.BNR_CLASS_**** = '';
  STORE.CONS.BNR_CLASS_ROTE = '02';
  STORE.CONS.BNR_CLASS_MIDDLE = '03';
  // STORE.CONS.BNR_CLASS_**** = '';
  STORE.CONS.BNR_CLASS_POPUP = '05';

  /** 緊急アナウンス判定ワード */
	STORE.CONS.REGEXP_EMERGANCY_ANNOUNCE_IRREGURAL   = /緊急事態宣言/;
	STORE.CONS.REGEXP_EMERGANCY_ANNOUNCE_IRREGURAL02 = /^＜.*?＞<br.*/;

  /** 店舗記事区分 */
	STORE.CONS.STORE_ARTICLE_CLASS_FAIR	  = '01';
	STORE.CONS.STORE_ARTICLE_CLASS_NEWS	  = '02';
	STORE.CONS.STORE_ARTICLE_CLASS_SPECIAL = '03';
	STORE.CONS.STORE_ARTICLE_CLASS_RECOMMEND = '04';
	STORE.CONS.STORE_ARTICLE_CLASS_DEALS = '05';
	STORE.CONS.STORE_ARTICLE_CLASS_OTHER1	= '09';
	STORE.CONS.STORE_ARTICLE_CLASS_OTHER2	= '10';
	STORE.CONS.STORE_ARTICLE_CLASS_ALL	    = '00';
	STORE.CONS.STORE_ARTICLE_CLASS_DATAS = {
		'01' : 'fa',
		'02' : 'ns',
		'03' : 'sp',
		'04' : 'rc',
		'05' : 'dl',
		'09' : 'o1',
		'10' : '02',
	};

  /** ショップ記事区分 */
	STORE.CONS.SHOP_ARTICLE_CLASS_RECOMMEND = '01';
	STORE.CONS.SHOP_ARTICLE_CLASS_DEALS	  = '02';
	STORE.CONS.SHOP_ARTICLE_CLASS_NEWS = '03';
	STORE.CONS.SHOP_ARTICLE_CLASS_SPECIAL = '04';
	STORE.CONS.SHOP_ARTICLE_CLASS_OTHER1	= '09';
	STORE.CONS.SHOP_ARTICLE_CLASS_OTHER2	= '10';
	STORE.CONS.SHOP_ARTICLE_CLASS_ALL	    = '00';
	STORE.CONS.SHOP_ARTICLE_CLASS_DATAS = {
		'01' : 'rc',
		'02' : 'dl',
		'03' : 'ns',
		'09' : 'o1',
		'10' : '02',
	};


  /** 特集区分 */
	STORE.CONS.FEATURE_CLASS_SPECIAL = '01';
	STORE.CONS.FEATURE_CLASS_RECOMMEND = '02';
	STORE.CONS.FEATURE_CLASS_DEALS	  = '03';
	STORE.CONS.FEATURE_CLASS_NEWS = '04';
	STORE.CONS.FEATURE_CLASS_OTHER1	= '09';
	STORE.CONS.FEATURE_CLASS_OTHER2	= '10';
	STORE.CONS.FEATURE_CLASS_ALL	    = '00';
	STORE.CONS.FEATURE_CLASS_DATAS = {
		'01' : 'sp',
		'02' : 'rc',
		'03' : 'dl',
		'04' : 'ns',
		'09' : 'o1',
		'10' : '02',
	};


  /** キャンペーン区分 */
	STORE.CONS.CAMPAIGN_CLASS_SPECIAL = '01';
	STORE.CONS.CAMPAIGN_CLASS_RECOMMEND = '02';
	STORE.CONS.CAMPAIGN_CLASS_DEALS	  = '03';
	STORE.CONS.CAMPAIGN_CLASS_NEWS = '04';
	STORE.CONS.CAMPAIGN_CLASS_SERVICE	= '05';
	STORE.CONS.CAMPAIGN_CLASS_ALL	    = '00';
	STORE.CONS.CAMPAIGN_CLASS_DATAS = {
		'01' : 'sp',
		'02' : 'rc',
		'03' : 'dl',
		'04' : 'ns',
		'05' : 'sv',
	};


	/** WEB投稿ステータス */
	STORE.CONS.WEB_POST_FLAG_OK	= '1';
	STORE.CONS.WEB_POST_FLAG_NG	= '0';

	/** MAIL投稿ステータス */
	STORE.CONS.MAIL_SEND_FLAG_OK	= '1';
	STORE.CONS.MAIL_SEND_FLAG_NG	= '0';

	/** WEB一覧表示フラグ */
	STORE.CONS.DISP_LIST_FLAG_OK	= '0';
	STORE.CONS.DISP_LIST_FLAG_NG	= '1';

	/** イベント最大終了日 */
	STORE.CONS.EVENT_MAX_END_DATE		= '9999/12/31';
	STORE.CONS.EVENT_MAX_END_DATE_STR	= '99991231';


	/** ショップ詳細情報区分 */
	STORE.CONS.SHOP_INTRO_ANCLY_SIZE		= '0'; // 取扱いサイズ
	STORE.CONS.SHOP_INTRO_ANCLY_EPOTOKU	= '1'; // エポトクURL
	STORE.CONS.SHOP_INTRO_ANCLY_BIZ_TIME	= '2'; // 営業時間・ラストオーダー
	STORE.CONS.SHOP_INTRO_ANCLY_SEAT		= '3'; // 座席数
	STORE.CONS.SHOP_INTRO_ANCLY_SMOKING	= '4'; // 喫煙・禁煙
	STORE.CONS.SHOP_INTRO_ANCLY_WEB_SITE	= '5'; // 公式HP URL
	STORE.CONS.SHOP_INTRO_ANCLY_WC_URL		= '6'; // ウェブチャネルショップURL
	STORE.CONS.SHOP_INTRO_ANCLY_RECRUIT	= '7'; // 採用情報
	STORE.CONS.SHOP_INTRO_ANCLY_OTHER1		= '8'; // 予備1
	STORE.CONS.SHOP_INTRO_ANCLY_OTHER2		= '9'; // 予備2
	STORE.CONS.SHOP_INTRO_ANCLY_INSTAGRAM		= '10'; // instagram
	STORE.CONS.SHOP_INTRO_ANCLY_TWITTER		= '11'; // twitter
	STORE.CONS.SHOP_INTRO_ANCLY_FACEBOOK		= '12'; // facebook
	STORE.CONS.SHOP_INTRO_ANCLY_LINE		= '13'; // line
	STORE.CONS.SHOP_INTRO_ANCLY_YOUTUBE		= '14'; // youtube
	STORE.CONS.SHOP_INTRO_ANCLY_TIKTOK		= '15'; // tiktok
	STORE.CONS.SHOP_INTRO_ANCLY_WEB_SITE2		= '16'; // 公式URL2

	STORE.CONS.STORE_CAMPAIGN_CLASS_SPECIAL   = '01'; // スペシャル
	STORE.CONS.STORE_CAMPAIGN_CLASS_RECOMMEND = '02'; // おすすめ
	STORE.CONS.STORE_CAMPAIGN_CLASS_SALE      = '03'; // お得情報
	STORE.CONS.STORE_CAMPAIGN_CLASS_INFO      = '04'; // お知らせ
	STORE.CONS.STORE_CAMPAIGN_CLASS_SERVICE   = '05'; // 優待・サービス・設備

	STORE.CONS.ANALYZE_SHOP_CATEGORY_CODE = {
		'レディス' : 'ld',
		'メンズ' : 'mn',
		'レディス＆メンズ' : 'lm',
		'ファミリー' : 'fa',
		'キッズ' : 'kd',
		'ファッション雑貨・生活雑貨' : 'sd',
		'スポーツ・アウトドア' : 'sp',
		'コスメ・ビューティ' : 'bt',
		'グルメ・フード' : 'gm',
		'サービス・エンターテイメント' : 'sv',
	};


	/** ネット通販ドメイン */
	STORE.CONS.EC_SITE_URL_ARY = [
		/^https?:\/\/voi.0101.co.jp\/.*/,
		/^https?:\/\/search-voi.0101.co.jp\/.*/,
	];

	/** TTS検索項目対象配列 */
	STORE.CONS.SEARCH_INFO_TAXFREE_ALL		= '1';
	STORE.CONS.SEARCH_INFO_TAXFREE_SINGLE	= '2';
	STORE.CONS.SEARCH_INFO_INBOUND			= '3';

	/**
	 * 頭文字マップ
	 */
	STORE.CONS.SHOP_NAME_INIT_KANA = {
		'ア行' : ['ア', 'ァ', 'イ', 'ウ', 'ヴ', 'エ', 'オ'],
		'カ行' : ['カ', 'キ', 'ク', 'ケ', 'コ', 'ガ', 'ギ', 'グ', 'ゲ', 'ゴ'],
		'サ行' : ['サ', 'シ', 'ス', 'セ', 'ソ', 'ザ', 'ジ', 'ズ', 'ゼ', 'ゾ'],
		'タ行' : ['タ', 'チ', 'ツ', 'テ', 'ト', 'ダ', 'ヂ', 'ヅ', 'デ', 'ド'],
		'ナ行' : ['ナ', 'ニ' ,'ヌ', 'ネ', 'ノ'],
		'ハ行' : ['ハ', 'ヒ', 'フ', 'ヘ', 'ホ', 'バ', 'ビ', 'ブ', 'ベ', 'ボ', 'パ', 'ピ', 'プ', 'ペ', 'ポ'],
		'マ行' : ['マ', 'ミ', 'ム', 'メ', 'モ'],
		'ヤ行' : ['ヤ', 'ユ', 'ヨ'],
		'ラ行' : ['ラ', 'リ', 'ル', 'レ', 'ロ'],
		'ワ行' : ['ワ', 'ヲ', 'ン'],
	};
	STORE.CONS.SHOP_SEARCH_INIT_KANA = {
		'ガ' : 'カ', 'ギ' : 'キ', 'グ' : 'ク', 'ゲ' : 'ケ', 'ゴ' : 'コ',
		'ザ' : 'サ', 'ジ' : 'シ', 'ズ' : 'ス', 'ゼ' : 'セ', 'ゾ' : 'ソ',
		'ダ' : 'タ', 'ヂ' : 'チ', 'ヅ' : 'ツ', 'デ' : 'テ', 'ド' : 'ト',
		'バ' : 'ハ', 'ビ' : 'ヒ', 'ブ' : 'フ', 'ベ' : 'ヘ', 'ボ' : 'ホ',
		'パ' : 'ハ', 'ピ' : 'ヒ', 'プ' : 'フ', 'ペ' : 'ヘ', 'ポ' : 'ホ',
	};

	/**
	 * ショップメール店舗番号変換
	 */
	STORE.CONS.SHOP_MAIL_CONV_STORE = {
		'726' : '093', // 川越モディ
		'060' : '092', // 戸塚モディ
		'724' : '096', // 静岡モディ
		'722' : '095', // 柏モディ
		'721' : '094', // 渋谷モディ
		'723' : '091', // 町田モディ
	};

	/**
	 * イレギュラーフロアデータ
	 */
	STORE.CONS.IRREGULAR_FLOORS = {
		// '079' : {
		// 	'floor' : '8F',
		// 	'map'   : 'フロア改装中<br><span>ご迷惑をおかけしております</span>',
		// 	'isIrregular' : true,
		// }
	};
	STORE.CONS.DELETE_FLOORS = {
		'079' : {
			'floor' : 'RF',
		}
		// '054' : {
		// 	'floor' : 'RF',
		// }
	};

  /**
	 * 翻訳関連
	 */
  STORE.CONS.TRANSER_DOMAIN_MASTER = {
		en : /.*?\.e\.sc\.hp\.transer\.com$|.*?\.e\.ex\.hp\.transer\.com$/,
		zh : /.*?\.t\.sc\.hp\.transer\.com$|.*?\.t\.ex\.hp\.transer\.com$/,
		cn : /.*?\.c\.sc\.hp\.transer\.com$|.*?\.c\.ex\.hp\.transer\.com$/,
		ko : /.*?\.k\.sc\.hp\.transer\.com$|.*?\.k\.ex\.hp\.transer\.com$/,
	};

  STORE.CONS.TRANSER_JP = 'jp';
	STORE.CONS.TRANSER_EN = 'en';
	STORE.CONS.TRANSER_ZH = 'zh';
	STORE.CONS.TRANSER_CN = 'cn';
	STORE.CONS.TRANSER_KO = 'ko';

  /** 施設情報区分 タイトル判定 */
	STORE.CONS.COMMON_OPEN_TIME = /^基本営業時間/;
	STORE.CONS.COMMON_EXTRA_OPEN_TIME = /^基本営業時間[2２]/;
	STORE.CONS.DIFFERENT_OPEN_TIME_SHOP = /^例外営業時間/;
	STORE.CONS.COMMON_CLOSE_INFO = /^休業日/;

  /** 施設情報区分 種別コード */
	STORE.CONS.FACILITY_INFO_CLASS_TIME			= '01';
	STORE.CONS.FACILITY_INFO_CLASS_ADDRESS			= '02';
	STORE.CONS.FACILITY_INFO_CLASS_TEL				= '03';
	STORE.CONS.FACILITY_INFO_CLASS_CLOSE			= '04';
	STORE.CONS.FACILITY_INFO_CLASS_SERVICE			= '05';
	STORE.CONS.FACILITY_INFO_CLASS_BICYCLE			= '06';
	STORE.CONS.FACILITY_INFO_CLASS_PARKING			= '07';
	STORE.CONS.FACILITY_INFO_CLASS_SUPPORT			= '08';
	STORE.CONS.FACILITY_INFO_CLASS_MARUI_PARKING	= '09';

	/** 施設情報ピクト */
	STORE.CONS.FACILITY_PICT = {
		'コインロッカー'	: '01',
		'車いす貸出'	: '02',
		'車イス貸出'	: '02',
		'ベビーカー貸出'	: '03',
		'授乳室'	: '04',
		'ベビーベッド付きトイレ'	: '05',
		'ベビーベッド付トイレ'	: '05',
		'ベビー休憩室'	: '05',
		'喫煙所': '06',
		'公衆電話': '07',
		'自動販売機': '08',
		'証明写真': '09',
		'ATM': '10',
		'セブン銀行': '10',
		'ATM': '10',
		'AED': '11',
		'パウダールーム': '12',
		'車いす対応化粧室': '13',
		'オストメイト': '14',
		'補助犬': '15',
		'更衣室': '16',
		'フィッティング付トイレ': '16',
		'駐輪場': '17',
		'オストメイト対応化粧室': '18',
		'ベビーチェア付きトイレ': '19',
		'筆談ボード': '20',
		'みんなのトイレ': '21',
		'車いす対応エレベーター': '22',
		'音声ガイド付エレベーター': '23',
		'音声ガイド付きエレベーター': '23',
		'点字付き店内案内板': '24',
		'屋上広場': '25',
		'屋上広場やテラス': '25',
		'エポスカードカウンター': '26',
		'エポスカードセンター': '26',
		'免税カウンター': '27',
		'Free Wi-Fi': '28',
		'Free Wifi': '28',
		'インフォメーションカウンター': '29',
		'キッズスペース': '30',
		'外貨両替所': '31',
		'呼び出しインターホン': '32',
		'キッズトイレ': '33',
		'ベビーカーで入れるトイレ': '34',
		'介護用大型ベッド付きトイレ'			: '35',
		'電動車椅子充電サービス'			: '36',
		'礼拝'	: '37',
	};

	STORE.CONS.GOOGLE_MAP_BASE_URL = 'http://maps.google.co.jp/maps?';

	STORE.CONS.STORE_COORDINATE_POINT_MASTER = {
		'086' : {
			marui : {
				name	: '有楽町マルイ',
				place	: '東京都千代田区有楽町2-7-1',
				url		: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d810.2786307333863!2d139.763776!3d35.674182!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188be5727dcea3%3A0xd60a27836288d3da!2z5pyJ5qW955S644Oe44Or44Kk!5e0!3m2!1sja!2sjp!4v1528362205536',
				lat		: 35.674182,
				lng		: 139.763776,
				zoom	: 16
			},
			parking : [
				{
					name	: 'タイムズステーション・イトシア',
					place	: '東京都千代田区有楽町2-7',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d810.2820856000455!2d139.7635334292281!3d35.67384169876226!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188be50affca7b%3A0xb51e2f1824097e7d!2z44K_44Kk44Og44K6IOOCueODhuODvOOCt-ODp-ODs-ODu-OCpOODiOOCt-OCog!5e0!3m2!1sja!2sjp!4v1528362302335',
					lat 	: 35.674333,
					lng		: 139.764127,
					zoom	: 15,
				},
			]
		},

		'003' : {
			marui : {
				name	: '新宿マルイ本館',
				place	: '東京都新宿区新宿3-30-13',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.4360094399426!2d139.7018997155771!3d35.69088678019201!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188cdb00c00001%3A0x1b7b25d83eb308ff!2z5paw5a6_44Oe44Or44KkIOacrOmkqA!5e0!3m2!1sja!2sjp!4v1528362376374',
				lat		: 35.690922,
				lng		: 139.704089,
				zoom	: 17,
			},
			parking : [
				{
					name	: '京王新宿追分ビル駐車場',
					place	: '東京都新宿区新宿3-1-13',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.467994117059!2d139.702604815259!3d35.69009948019219!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188d97e36f1917%3A0x18de0f8cc071e333!2zYWtpcHBhIHwg5Lqs546L5paw5a6_6L-95YiG44OT44Or6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1639989734097!5m2!1sja!2sjp',
					lat 	: 35.6900995,
					lng		: 139.7026048,
					zoom	: 17,
				},
				{
					name	: '新宿３丁目イーストビル駐車場',
					place	: '東京都新宿区新宿3-1-26',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.4706144527913!2d139.7037573155769!3d35.6900349801923!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188cdb5af2d605%3A0x2e220d57e38671d3!2z5paw5a6_77yT5LiB55uu44Kk44O844K544OI44OT44Or56uL5L2T6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1528362476879',
					lat 	: 35.690035,
					lng		: 139.705945,
					zoom	: 17,
				},
				{
					name	: '新宿サブナード駐車場',
					place	: '東京都新宿区歌舞伎町1-2-2',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.343165909242!2d139.7014473155771!3d35.69317203019155!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188cda29b4745b%3A0xec62f87ea249be9a!2z44K144OW44OK44O844OJ6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1528362505774',
					lat 	: 35.693469,
					lng		: 139.703832,
					zoom	: 17,
				},
				{
					name	: 'Park one 新宿マルイメン駐車場',
					place	: '東京都新宿区新宿5-16-4',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.3646358625865!2d139.70418631525908!3d35.692643580191664!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188cdc823ab15f%3A0xa2d7db2e6f120dc5!2z5paw5a6_44Oe44Or44Kk44Oh44Oz6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1639984405005!5m2!1sja!2sjp',
					lat 	: 35.692641,
					lng		: 139.706348,
					zoom	: 17,
				},
			]
		},

		'005' : {
			marui : {
				name	: '新宿マルイアネックス',
				place	: '東京都新宿区新宿3-1-26',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.4698060085652!2d139.703618015577!3d35.69005488019218!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188cdb5b6aaaab%3A0x8717a26828d19a93!2z5paw5a6_44Oe44Or44KkIOOCouODjeODg-OCr-OCuQ!5e0!3m2!1sja!2sjp!4v1528362599742',
				lat		: 35.690055,
				lng		: 139.705806,
				zoom	: 17,
			},
			parking : [
				{
					name	: '京王新宿追分ビル駐車場',
					place	: '東京都新宿区新宿3-1-13',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.467994117059!2d139.702604815259!3d35.69009948019219!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188d97e36f1917%3A0x18de0f8cc071e333!2zYWtpcHBhIHwg5Lqs546L5paw5a6_6L-95YiG44OT44Or6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1639989734097!5m2!1sja!2sjp',
					lat 	: 35.6900995,
					lng		: 139.7026048,
					zoom	: 17,
				},
				{
					name	: '新宿３丁目イーストビル駐車場',
					place	: '東京都新宿区新宿3-1-26',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.4706144527913!2d139.7037573155769!3d35.6900349801923!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188cdb5af2d605%3A0x2e220d57e38671d3!2z5paw5a6_77yT5LiB55uu44Kk44O844K544OI44OT44Or56uL5L2T6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1528362476879',
					lat 	: 35.690035,
					lng		: 139.705945,
					zoom	: 17,
				},
				{
					name	: '新宿サブナード駐車場',
					place	: '東京都新宿区歌舞伎町1-2-2',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.343165909242!2d139.7014473155771!3d35.69317203019155!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188cda29b4745b%3A0xec62f87ea249be9a!2z44K144OW44OK44O844OJ6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1528362505774',
					lat 	: 35.693469,
					lng		: 139.703832,
					zoom	: 17,
				},
				{
					name	: 'Parkone新宿マルイメン駐車場',
					place	: '東京都新宿区新宿5-16-4',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.3646358625865!2d139.70418631525908!3d35.692643580191664!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188cdc823ab15f%3A0xa2d7db2e6f120dc5!2z5paw5a6_44Oe44Or44Kk44Oh44Oz6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1639984405005!5m2!1sja!2sjp',
					lat 	: 35.692641,
					lng		: 139.706348,
					zoom	: 17,
				},
			]
		},
		'074' : {
			marui : {
				name	: '新宿マルイメン',
				place	: '東京都新宿区新宿5-16-4',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.3642823997875!2d139.704160715577!3d35.69265228019172!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188cdb89961179%3A0x8d6676819f452054!2z5paw5a6_44Oe44Or44KkIOODoeODsw!5e0!3m2!1sja!2sjp!4v1528362698426',
				lat		: 35.692653,
				lng		: 139.706349,
				zoom	: 17,
			},
			parking : [
				{
					name	: '京王新宿追分ビル駐車場',
					place	: '東京都新宿区新宿3-1-13',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.467994117059!2d139.702604815259!3d35.69009948019219!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188d97e36f1917%3A0x18de0f8cc071e333!2zYWtpcHBhIHwg5Lqs546L5paw5a6_6L-95YiG44OT44Or6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1639984980112!5m2!1sja!2sjp',
					lat 	: 35.6900995,
					lng		: 139.7026048,
					zoom	: 17,
				},
				{
					name	: '新宿３丁目イーストビル駐車場',
					place	: '東京都新宿区新宿3-1-26',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.4706144527913!2d139.7037573155769!3d35.6900349801923!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188cdb5af2d605%3A0x2e220d57e38671d3!2z5paw5a6_77yT5LiB55uu44Kk44O844K544OI44OT44Or56uL5L2T6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1528362476879',
					lat 	: 35.690035,
					lng		: 139.705945,
					zoom	: 17,
				},
				{
					name	: '新宿サブナード駐車場',
					place	: '東京都新宿区歌舞伎町1-2-2',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.343165909242!2d139.7014473155771!3d35.69317203019155!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188cda29b4745b%3A0xec62f87ea249be9a!2z44K144OW44OK44O844OJ6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1528362505774',
					lat 	: 35.693469,
					lng		: 139.703832,
					zoom	: 17,
				},
				{
					name	: 'Park　One　新宿マルイメン駐車場',
					place	: '東京都新宿区新宿5-16-4',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.3646358625865!2d139.70418631525908!3d35.692643580191664!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188cdc823ab15f%3A0xa2d7db2e6f120dc5!2z5paw5a6_44Oe44Or44Kk44Oh44Oz6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1639984405005!5m2!1sja!2sjp',
					lat 	: 35.692641,
					lng		: 139.706348,
					zoom	: 17,
				},
			]
		},
		'013' : {
			marui : {
				name	: '渋谷マルイ',
				place	: '東京都渋谷区神南1-22-6',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.653725082299!2d139.69888391557635!3d35.660902180199024!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188ca80b62dab7%3A0xe676ff8355b79831!2z5riL6LC344Oe44Or44Kk!5e0!3m2!1sja!2sjp!4v1528362835760',
				lat		: 35.660902,
				lng		: 139.701072,
				zoom	: 17,
			},
			parking : [
				{
					name	: '渋谷区役所前公共駐車場',
					place	: '東京都渋谷区宇田川町1-1',
					url		: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12966.158413719366!2d139.6991168!3d35.6637132!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x73879bb42139f0ae!2z5riL6LC35Yy65b255omA5YmN5YWs5YWx6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1626341939069!5m2!1sja!2sjp',
					lat 	: 35.664536,
					lng		: 139.698570,
					zoom	: 15,
				},
				{
					name	: '渋谷マルイ・渋谷モディ駐車場',
					place	: '東京都渋谷区神南1丁目１２番２０号',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.5906896038396!2d139.69825941563582!3d35.66245488019854!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188ca88e139225%3A0xbef8bf8e792e1b13!2z44CSMTUwLTAwNDEg5p2x5Lqs6YO95riL6LC35Yy656We5Y2X77yR5LiB55uu77yR77yS4oiS77yS77yQ!5e0!3m2!1sja!2sjp!4v1528444565532',
					lat 	: 35.664536,
					lng		: 139.698570,
					zoom	: 15,
				},
			]
		},
		'058' : {
			marui : {
				name	: '上野マルイ',
				place	: '東京都台東区上野6-15-1',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3239.627467047313!2d139.77362621557756!3d35.71078398018749!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188e9ef1201551%3A0xf0efc14bd6161139!2z5LiK6YeO44Oe44Or44Kk!5e0!3m2!1sja!2sjp!4v1528363599862',
				lat		: 35.710785,
				lng		: 139.775814,
				zoom	: 17,
			},
			parking : [
				{
					name	: '上野パーキングセンター',
					place	: '東京都台東区上野公園1-50',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3239.5508885952268!2d139.77253231557754!3d35.712667980186986!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188e9dd9cb6b2b%3A0x3600b99890f98727!2z77yI5qCq77yJ5LiK6YeO44OR44O844Kt44Oz44Kw44K744Oz44K_44O8!5e0!3m2!1sja!2sjp!4v1528363628039',
					lat 	: 35.712670,
					lng		: 139.774720,
					zoom	: 16,
				},
				{
					name	: '京成上野駅駐車場',
					place	: '東京都台東区上野公園1-12',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3239.5954093922587!2d139.77106181557733!3d35.711572680187395!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188e9ddc56df3d%3A0x420d127addce6e25!2z5Lqs5oiQ5LiK6YeO6aeF6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1528363655063',
					lat 	: 35.711955,
					lng		: 139.773155,
					zoom	: 16,
				},
				{
					name	: '上野中央通り地下駐車場',
					place	: '東京都台東区上野2丁目13番',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3239.659617572063!2d139.77136431557759!3d35.70999298018766!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188e9e31e7fb3d%3A0x79fc4a7076dea8ed!2z5LiK6YeO5Lit5aSu6YCa44KK5Zyw5LiL6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1528363680230',
					lat 	: 35.709994,
					lng		: 139.773553,
					zoom	: 16,
				},
			]
		},
		'054' : {
			marui : {
				name	: '錦糸町マルイ',
				place	: '東京都墨田区江東橋3-9-10',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.267536417533!2d139.8115877155771!3d35.69503348019111!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601888d809ff4821%3A0x9f1e6e4f209907dd!2z5Li45LqV6Yym57O455S65bqX!5e0!3m2!1sja!2sjp!4v1528363980299',
				lat		: 35.695033,
				lng		: 139.813777,
				zoom	: 17,
			},
			parking : [
				{
					name	: '錦糸町マルイ　地下２階駐車場',
					place	: '東京都墨田区江東橋3-9-10',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d810.0667640564579!2d139.8131211292443!3d35.69504529876193!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188927f66f7ed9%3A0x2c0b1e19beaeb5be!2z44CSMTMwLTAwMjIg5p2x5Lqs6YO95aKo55Sw5Yy65rGf5p2x5qmL77yT5LiB55uu77yZ4oiS77yR77yQ!5e0!3m2!1sja!2sjp!4v1528364057518',
					lat		: 35.695033,
					lng		: 139.813777,
					zoom	: 17,
				},
			]
		},
		'016' : {
			marui : {
				name	: '吉祥寺マルイ',
				place	: '東京都武蔵野市吉祥寺南町1-7-1',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3239.9888017849867!2d139.57701071557727!3d35.70189318018951!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018ee381ca259a5%3A0x9aa70328fa61e0c1!2z5Li45LqV5ZCJ56Wl5a-65bqX!5e0!3m2!1sja!2sjp!4v1528364285154',
				lat		: 35.701892,
				lng		: 139.579195,
				zoom	: 17,
			},
			parking : [
				{
					name	: 'タイムズ吉祥寺マルイ駐車場',
					place	: '東京都武蔵野市吉祥寺南町1-7-1',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3239.9953605892283!2d139.5771669155773!3d35.70173178018957!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018ee38033171d9%3A0x8c274a146ff4b598!2z44K_44Kk44Og44K6IOS4uOS6leWQieelpeWvuuW6lw!5e0!3m2!1sja!2sjp!4v1528364310846',
					lat 	: 35.701733,
					lng		: 139.579355,
					zoom	: 17,
				},
			]
		},
		'062' : {
			marui : {
				name	: '国分寺マルイ',
				place	: '東京都国分寺市南町3-20-3',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.0728004869393!2d139.47810841557717!3d35.69982608018999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018e4363008e727%3A0x6a039cdb45510699!2z5Zu95YiG5a-644Oe44Or44Kk!5e0!3m2!1sja!2sjp!4v1528364409382',
				lat		: 35.699825,
				lng		: 139.480296,
				zoom	: 17,
			},
			parking : [
				{
					name	: '国分寺ターミナルビル駐車場',
					place	: '東京都国分寺市南町3-20-3',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.075770902264!2d139.47717731557728!3d35.69975298019004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018e437cbdd8377%3A0x8922d300229858ab!2z5Zu95YiG5a-644K_44O844Of44OK44Or44OT44Or44OR44O844Kt44Oz44Kw44K744Oz44K_44O8!5e0!3m2!1sja!2sjp!4v1528364445846',
					lat 	: 35.699753,
					lng		: 139.479367,
					zoom	: 17,
				},
			]
		},
		'052' : {
			marui : {
				name	: '町田マルイ',
				place	: '東京都町田市原町田6-1-6',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3246.449693358156!2d139.44291891557367!3d35.54259458022685!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018feb49ead2547%3A0x9a3bf846e2ffb8eb!2z55S655Sw44Oe44Or44Kk!5e0!3m2!1sja!2sjp!4v1528364511813',
				lat		: 35.542595,
				lng		: 139.445108,
				zoom	: 17,
			},
			parking : [
				{
					name	: '市営原町田一丁目駐車場',
					place	: '東京都町田市原町田1-6-21',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3246.53634184212!2d139.44547231557345!3d35.540453980227376!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f94abf6cfad7%3A0xd6046b07da659d41!2z5biC5Za25Y6f55S655Sw77yR5LiB55uu6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1528364537141',
					lat 	: 35.540454,
					lng		: 139.447661,
					zoom	: 16,
				},
				{
					name	: 'ぽっぽ町田パーキング',
					place	: '東京都町田市原町田4-10-20',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3246.4594408304265!2d139.44686241557352!3d35.542353780227025!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f94b007a3f4d%3A0x9016d44507bd00f1!2z44CSMTk0LTAwMTMg5p2x5Lqs6YO955S655Sw5biC5Y6f55S655Sw77yU5LiB55uu77yR77yQ4oiS77yS77yQ!5e0!3m2!1sja!2sjp!4v1528364617951',
					lat 	: 35.542434,
					lng		: 139.449189,
					zoom	: 16,
				},
				{
					name	: 'アイパーク駐車場　町田森野第1',
					place	: '東京都町田市森野1丁目24-13',
					url		: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3246.3421022375614!2d139.4430065!3d35.5452524!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018ff007158ef11%3A0xa9b478f43ac95918!2z44Ki44Kk44OR44O844Kv6aeQ6LuK5aC055S655Sw5qOu6YeO56ysMQ!5e0!3m2!1sja!2sjp!4v1767005418018!5m2!1sja!2sjp',
					lat 	: 35.5452524,
					lng		: 139.4430065,
					zoom	: 16,
				},
				{
					name	: 'パークワン',
					place	: '東京都町田市森野1-24',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3246.3336179297257!2d139.44082231557363!3d35.54546198022611!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018feb241c3e789%3A0xa6b26b773509bb64!2z44OR44O844Kv44Ov44Oz44Oe44OB44OAIOmnkOi7iuWgtA!5e0!3m2!1sja!2sjp!4v1528364772070',
					lat 	: 35.545460,
					lng		: 139.443012,
					zoom	: 16,
				},
				{
					name	: 'アミックスパーキング',
					place	: '東京都町田市原町田6丁目18-16',
					url		: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1623.1880818404031!2d139.447377!3d35.544411!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f942f6c878bb%3A0x42ce9e736fa477e1!2z44Ki44Of44OD44Kv44K544OR44O844Kt44Oz44Kw!5e0!3m2!1sja!2sjp!4v1767004899017!5m2!1sja!2sjp',
					lat 	: 35.544411,
					lng		: 139.447377,
					zoom	: 16,
				},
			]
		},
		'077' : {
			marui : {
				name	: 'マルイシティ横浜',
				place	: '神奈川県横浜市西区高島2-19-12',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3249.600687197539!2d139.62249661563135!3d35.46467898024535!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60185c13590d1bad%3A0x73fc678dc8a23cc2!2z44Oe44Or44Kk44K344OG44Kj5qiq5rWc!5e0!3m2!1sja!2sjp!4v1528415126354',
				lat		:35.464679,
				lng		: 139.624685,
				zoom	: 16,
			},
			parking : [
				{
					name	: 'スカイビル駐車場',
					place	: '神奈川県横浜市西区高島2-19-12',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3249.5939823782483!2d139.6227363656313!3d35.4648449302453!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60185c14a58a9fc9%3A0x7675665a17ff0159!2z44K544Kr44Kk44OT44Or6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1528416817980',
					lat 	: 35.464639,
					lng		: 139.625212,
					zoom	: 16,
				},
				{
					name	: '横浜駅東口地下駐車場',
					place	: '神奈川県横浜市西区高島2-18-1横浜新都市ビルB3F',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3249.607557639401!2d139.62167771563128!3d35.46450893024547!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60185c13bb25bdd5%3A0x9626edf13a3beead!2z5qiq5rWc6aeF5p2x5Y-j5Zyw5LiL6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1528416851219',
					lat 	: 35.465129,
					lng		: 139.624640,
					zoom	: 16,
				},
				{
					name	: '横浜駅東口（岩井パーキング）',
					place	: '神奈川県横浜市西区高島2-6-38',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3249.7342809473034!2d139.62112621563122!3d35.46137228024607!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60185c6c5e5b51c9%3A0x1579b74eb8ddecc0!2z5qiq5rWc6aeF5p2x5Y-j56ys77yS6aeQ6LuK5aC0IOWyqeS6leODkeODvOOCreODs-OCsA!5e0!3m2!1sja!2sjp!4v1528416880682',
					lat 	: 35.461373,
					lng		: 139.623315,
					zoom	: 15,
				},
				{
					name	: '横浜市ポートサイド地下駐車場',
					place	: '神奈川県横浜市神奈川区栄町6',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3249.4739394806!2d139.62580311563147!3d35.4678159802446!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60185c1583e75017%3A0xd95a5fd1427edacb!2z5qiq5rWc5biC44Od44O844OI44K144Kk44OJ5Zyw5LiL6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1528416911147',
					lat 	: 35.467815,
					lng		: 139.627990,
					zoom	: 15,
				},
			]
		},
		'082' : {
			marui : {
				name	: '海老名マルイ',
				place	: '神奈川県海老名市中央1-6-1',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3250.0814480194954!2d139.39120231563098!3d35.45277798024819!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018556f82666af1%3A0x59daad3a6d28bd50!2z44Oe44Or44Kk44OV44Kh44Of44Oq44O85rW36ICB5ZCN!5e0!3m2!1sja!2sjp!4v1528417529968',
				lat		: 35.452777,
				lng		: 139.393392,
				zoom	: 17,
			},
			parking : [
				{
					name	: 'ビナウォーク駐車場（第1～第3駐車場)',
					place	: '神奈川県海老名市中央1-6-1',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3250.080678574894!2d139.39319181563107!3d35.45279703024809!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018556fec93c1e1%3A0xdf26645c7f04f380!2z44OT44OK44Km44Kp44O844Kv56ys77yR6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1528417613116',
					lat 	: 35.452884,
					lng		: 139.394619,
					zoom	: 17,
				},
			]
		},
		'076' : {
			marui : {
				name	: '柏マルイ',
				place	: '千葉県柏市柏1-1-11',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3233.4926808861105!2d139.9686539656403!3d35.86144143015276!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60189ce7721f9731%3A0x304e7ca50d0371cd!2z5p-P44Oe44Or44Kk!5e0!3m2!1sja!2sjp!4v1528424010129',
				lat		: 35.861458,
				lng		: 139.970882,
				zoom	: 17,
			},
			parking : [
				{
					name	: '柏モディ（旧マルイ館）地下駐車場',
					place	: '千葉県柏市柏1-2-26',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3233.533142270066!2d139.96842631564047!3d35.860449580152846!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60189ce771ee3c8d%3A0xf22749ee31aee35d!2z44CSMjc3LTAwMDUg5Y2D6JGJ55yM5p-P5biC5p-P77yR5LiB55uu77yS4oiS77yS77yW!5e0!3m2!1sja!2sjp!4v1528424151633',
					lat 	: 35.860473,
					lng		: 139.970590,
					zoom	: 17,
				},
				{
					name	: 'タイムズ24柏中央町駐車場',
					place	: '千葉県柏市中央町3-3',
					url		: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6467.112264889477!2d139.969542!3d35.859886!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x5cdfe952faca2351!2z44K_44Kk44Og44K65p-P5Lit5aSu55S6!5e0!3m2!1sja!2sus!4v1527753770520',
					lat 	: 35.859886,
					lng		: 139.969542,
					zoom	: 16,
				},
				{
					name	: '柏市営駐車場',
					place	: '千葉県柏市中央町1-1',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3233.5796215911973!2d139.9698624156402!3d35.85931018015324!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60189cdde3945bf5%3A0xf9012dfe54f14a03!2z44K_44Kk44Og44K65p-P5biC5Za26aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1528424173234',
					lat 	: 35.859503,
					lng		: 139.972463,
					zoom	: 16,
				},
				{
					name	: '東葉駐車場',
					place	: '千葉県柏市末広町5-19',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3233.5179833874818!2d139.9704154156403!3d35.860821180152826!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60189ce5ddc01dd3%3A0xe74d04bd536c455a!2z5p2x6JGJ56uL5L2T6aeQ6LuK5aC077yI6Ieq6LWw5byP77yJ!5e0!3m2!1sja!2sjp!4v1528424206938',
					lat 	: 35.863810,
					lng		: 139.968817,
					zoom	: 16,
				},
			]
		},
		'088' : {
			marui : {
				name	: '京都マルイ',
				place	: '京都市下京区四条通河原町東入真町68番地',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3268.1268473591463!2d135.76745571562094!3d35.0035296803578!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x600108956f4c8f0d%3A0x4449265ed9603f58!2z5Lqs6YO944Oe44Or44Kk!5e0!3m2!1sja!2sjp!4v1528426753482',
				lat		: 35.003483,
				lng		: 135.769737,
				zoom	: 17,
			},
			parking : [
			]
		},
		'036' : {
			marui : {
				name	: '静岡マルイ',
				place	: '静岡県静岡市葵区御幸町6-10',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3269.3061501418288!2d138.38558541562026!3d34.9739954803652!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601a49f7bbbac03b%3A0xb1fb62b6c719876d!2z6Z2Z5bKh44Oe44Or44Kk!5e0!3m2!1sja!2sjp!4v1528426828967',
				lat		: 34.974067,
				lng		: 138.387841,
				zoom	: 16,
			},
			parking : [
				{
					name	: 'しまのパーキング',
					place	: '静岡県静岡市葵区伝馬8-1',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3269.268808878258!2d138.38492831562021!3d34.974930980365!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601a49f7dadfe9f5%3A0x655a395943bf99d5!2z44GX44G-44Gu44OR44O844Kt44Oz44Kw!5e0!3m2!1sja!2sjp!4v1528426845088',
					lat 	: 34.974931,
					lng		: 138.387118,
					zoom	: 17,
				},
				{
					name	: '伝馬町パーキング',
					place	: '静岡県静岡市葵区伝馬町11-1',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3269.299208844083!2d138.38637621562034!3d34.97416938036519!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601a49f787d23079%3A0xb15784f267b9a87c!2z5Lyd6aas55S644OR44O844Kt44Oz44Kw!5e0!3m2!1sja!2sjp!4v1528426863041',
					lat 	: 34.974169,
					lng		: 138.388566,
					zoom	: 17,
				},
				{
					name	: '関川パーキング',
					place	: '静岡県静岡市葵区伝馬町10-4',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3269.270760784176!2d138.38639531562035!3d34.974882080364964!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601a49f78ca4670d%3A0xf9127167c387ab80!2z6Zai5bed44OR44O844Kt44Oz44Kw!5e0!3m2!1sja!2sjp!4v1528426882288',
					lat 	: 34.974881,
					lng		: 138.388585,
					zoom	: 17,
				},
				{
					name	: 'パークワン静岡',
					place	: '静岡県静岡市葵区伝馬町11-25',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3269.283382253284!2d138.3868426156204!3d34.97456588036514!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601a49f82637d2ed%3A0x2d79b3a0586aa1bc!2z44OR44O844Kv44Ov44Oz6Z2Z5bKh!5e0!3m2!1sja!2sjp!4v1528426902936',
					lat 	: 34.974566,
					lng		: 138.389030,
					zoom	: 17,
				},
				{
					name	: '新静岡セノバ駐車場',
					place	: '静岡県静岡市葵区鷹匠1丁目1-1',
					url		: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3269.245660464235!2d138.3845236!3d34.9755109!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601a49f7fe13a295%3A0x48d30a668533c7d3!2z5paw6Z2Z5bKh44K744OO44OQ6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1528426954780',
					lat 	: 34.975509,
					lng		: 138.387439,
					zoom	: 16,
				},
			]
		},
		'048' : {
			marui : {
				name	: '池袋マルイ',
				place	: '東京都豊島区西池袋3-28-13',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3238.793272401573!2d139.7054277155781!3d35.73130238018272!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188d5c1fda7ac1%3A0xd075d5a04a38c9cb!2z5rGg6KKL44Oe44Or44Kk!5e0!3m2!1sja!2sjp!4v1528363456032',
				lat		: 35.731303,
				lng		: 139.707617,
				zoom	: 17,
			},
			parking : [
				{
					name	: '丸井駐車場',
					place	: '東京都豊島区西池袋3-28-13',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3238.793272401573!2d139.7054277155781!3d35.73130238018272!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188d5ea657da6f%3A0x42dd29a830bab4a9!2z5Li45LqV6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1528363485670',
					lat		: 35.731303,
					lng		: 139.707617,
					zoom	: 17,
				},
			]
		},
		'084' : {
			marui : {
				name	: '北千住マルイ',
				place	: '東京都足立区千住3-92',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3237.99930344235!2d139.80243131557847!3d35.7508218801782!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188e4f41a624a9%3A0xde2d62f43cf2ddb9!2z5YyX5Y2D5L2P44Oe44Or44Kk!5e0!3m2!1sja!2sjp!4v1528363766608',
				lat		: 35.750822,
				lng		: 139.804620,
				zoom	: 17,
			},
			parking : [
				{
					name	: '北千住駅前駐車場（マルイ地下）',
					place	: '東京都足立区千住3-92',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3237.9749734514917!2d139.8028584155784!3d35.751419880178005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188e4f41737791%3A0xd413933fde248b6d!2z5YyX5Y2D5L2P6aeF5YmN6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1528363800070',
					lat 	: 35.751218,
					lng		: 139.804563,
					zoom	: 17,
				},
				{
					name	: '北千住西口立体駐車場（ルミネ横）',
					place	: '東京都足立区千住旭町42-2',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3237.994173017105!2d139.8029973155785!3d35.75094798017812!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188e4fa189ec97%3A0xc1388277c8754688!2z5YyX5Y2D5L2P6aeF6KW_5Y-j56uL5L2T6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1528363827022',
					lat 	: 35.749271,
					lng		: 139.805051,
					zoom	: 17,
				}
			]
		},
		'001' : {
			marui : {
				name	: '中野マルイ',
				place	: '中野区中野3-34-28',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3239.8726246025158!2d139.66290731557729!3d35.70475198018891!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f293fcaf58e7%3A0xf891be69adac1e33!2z5Lit6YeO44Oe44Or44Kk!5e0!3m2!1sja!2sjp!4v1528364150695',
				lat		: 35.704751,
				lng		: 139.665096,
				zoom	: 18,
			},
			parking : [
				{
					name	: '丸井駐車場',
					place	: '中野区中野3-34-28',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3239.8726246025158!2d139.66290731557729!3d35.70475198018891!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f293f408c57b%3A0x8028ce9ab61a0cb!2z5Li45LqV6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1528364188126',
					lat 	: 35.704259,
					lng		: 139.665315,
					zoom	: 17,
				},
			]
		},
		'999' : {
			marui : {
				name	: '中野マルイ',
				place	: '中野区中野3-34-28',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3239.8726246025158!2d139.66290731557729!3d35.70475198018891!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f293fcaf58e7%3A0xf891be69adac1e33!2z5Lit6YeO44Oe44Or44Kk!5e0!3m2!1sja!2sjp!4v1528364150695',
				lat		: 35.704751,
				lng		: 139.665096,
				zoom	: 18,
			},
			parking : [
				{
					name	: '丸井駐車場',
					place	: '中野区中野3-34-28',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3239.8726246025158!2d139.66290731557729!3d35.70475198018891!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f293f408c57b%3A0x8028ce9ab61a0cb!2z5Li45LqV6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1528364188126',
					lat 	: 35.704259,
					lng		: 139.665315,
					zoom	: 17,
				},
			]
		},
		// '061' : {
		// 	marui : {
		// 		name	: '丸井川崎店',
		// 		place	: '神奈川県川崎市川崎区日進町1-11',
		// 		lat		: 35.529575,
		// 		lng		: 139.696738,
		// 		zoom	: 16,
		// 	},
		// 	parking : [
		// 		{
		// 			name	: 'ルフロン駐車場',
		// 			place	: '神奈川県川崎市川崎区日進町1-41',
		// 			lat 	: 35.529898,
		// 			lng		: 139.695845,
		// 			zoom	: 16,
		// 		},
		// 		{
		// 			name	: 'ミューザ川崎駐車場',
		// 			place	: '神奈川県川崎市幸区大宮町1310',
		// 			lat 	: 35.530987,
		// 			lng		: 139.694262,
		// 			zoom	: 16,
		// 		},
		// 		{
		// 			name	: 'タイムズステーション川崎',
		// 			place	: '神奈川県川崎市川崎区駅前本町14',
		// 			lat 	: 35.532514,
		// 			lng		: 139.698879,
		// 			zoom	: 15,
		// 		},
		// 	]
		// },
		'078' : {
			marui : {
				name	: 'マルイファミリー溝口',
				place	: '神奈川県川崎市高津区溝口1-4-1',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3244.163686055918!2d139.61057921563426!3d35.59902868021353!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f426584bbdc1%3A0xd09c132dc984aa61!2z44Oe44Or44Kk44OV44Kh44Of44Oq44O85rqd5Y-j!5e0!3m2!1sja!2sjp!4v1528417384267',
				lat		: 35.599028,
				lng		: 139.612769,
				zoom	: 17,
			},
			parking : [
				{
					name	: 'ノクティ駐車場',
					place	: '神奈川県川崎市高津区溝口1-4-1',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3244.1850197235126!2d139.61103441563432!3d35.598502380213816!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f42701b8c795%3A0x5b4e3524210ac0bf!2z44OO44Kv44OG44Kj6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1528417405892',
					lat 	: 35.598503,
					lng		: 139.613224,
					zoom	: 17,
				},
				{
					name	: '持田駐車場',
					place	: '神奈川県川崎市高津区久本3-1-9',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3244.198290804819!2d139.61113951563433!3d35.59817498021368!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f4263fe145ef%3A0xadef1c4d31fd0e81!2z5oyB55Sw6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1528417426739',
					lat 	: 35.598187,
					lng		: 139.613329,
					zoom	: 17,
				},
			]
		},
		'053' : {
			marui : {
				name	: '大宮マルイ',
				place	: '埼玉県さいたま市大宮区桜木町2-3',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3231.635145251193!2d139.6196367156415!3d35.90695058014218!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018c1437a6e3ccd%3A0xf9a7f3ee5ece157b!2z5aSn5a6u44Oe44Or44Kk!5e0!3m2!1sja!2sjp!4v1528418423291',
				lat		: 35.906950,
				lng		: 139.621825,
				zoom	: 17,
			},
			parking : [
				{
					name	: 'B2・B3F駐車場',
					place	: '埼玉県さいたま市大宮区桜木町2-3',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3231.6354576706954!2d139.61944381564143!3d35.9069429301423!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018c1437c534b45%3A0x52c91e9f85b41cd5!2zRE9N44K344On44OD44OU44Oz44Kw44K744Oz44K_44O8!5e0!3m2!1sja!2sjp!4v1528419607499',
					lat		: 35.906950,
					lng		: 139.621825,
					zoom	: 17,
				},
				{
					name	: 'DOM PART2立体駐車場',
					place	: '埼玉県さいたま市大宮区桜木町2-6',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3231.626373793296!2d139.61955124950975!3d35.907165360178475!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018c144a019dc9f%3A0xb2dab6f6da133574!2z77yk77yv77yt44OR44O844Kt44Oz44Kw56uL5L2T6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1528419556220',
					lat		: 35.907068,
					lng		: 139.621021,
				},
				{
					name	: 'さいたま市営　桜木駐車場',
					place	: '埼玉県さいたま市大宮区桜木町3-1-1',
					lat 	: 35.910390,
					lng		: 139.618820,
					zoom	: 15,
				},
			]
		},
		'079' : {
			marui : {
				name	: 'マルイファミリー志木',
				place	: '埼玉県志木市本町5-26-1',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3235.044455352672!2d139.57199231563945!3d35.823384980161435!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018e9d15bd93075%3A0xd3b92923efd4b01!2z44Oe44Or44Kk44OV44Kh44Of44Oq44O85b-X5pyo!5e0!3m2!1sja!2sjp!4v1528419659579',
				lat		: 35.823385,
				lng		: 139.574180,
				zoom	: 17,
			},
			parking : [
				{
					name	: '丸井駐車場',
					place	: '埼玉県志木市本町5-26-1',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3235.044455352672!2d139.57199231563945!3d35.823384980161435!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018e9d15bd93075%3A0xa9922f58beab0b13!2z44K_44Kk44Og44K644Oe44Or44Kk44OV44Kh44Of44Oq44O85b-X5pyo!5e0!3m2!1sja!2sjp!4v1528419710999',
					lat		: 35.823385,
					lng		: 139.574180,
					zoom	: 17,
				},
				{
					name	: '市営駐車場',
					place	: '埼玉県志木市本町5-26-1',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3235.056168830253!2d139.5722136156395!3d35.82309758016146!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018e9d1507dfd7d%3A0x712993466775ef9f!2z5b-X5pyo5biC5b255omAIOW_l-acqOmnheadseWPo-WcsOS4i-mnkOi7iuWgtA!5e0!3m2!1sja!2sjp!4v1528419750386',
					lat 	: 35.823098,
					lng		: 139.574402,
					zoom	: 17,
				},
			]
		},
		'066' : {
			marui : {
				name	: '草加マルイ',
				place	: '埼玉県草加市高砂2-9-1',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3234.826803807486!2d139.80254311563962!3d35.82872488016034!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601891183fbe298f%3A0x10d2dcb9de3cfaae!2z6I2J5Yqg44Oe44Or44Kk!5e0!3m2!1sja!2sjp!4v1528419837130',
				lat		: 35.828724,
				lng		: 139.804732,
				zoom	: 18,
			},
			parking : [
				{
					name	: 'シティパーキングアコス',
					place	: '埼玉県草加市高砂2-7-2',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3234.862347993295!2d139.8013281156396!3d35.82785288016046!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60189118313f6383%3A0xe89b28b11397ceb7!2z44K344OG44Kj44OR44O844Kt44Oz44Kw44Ki44Kz44K5!5e0!3m2!1sja!2sjp!4v1528419863189',
					lat 	: 35.827591,
					lng		: 139.803687,
					zoom	: 17,
				},
			]
		},
		'085' : {
			marui : {
				name	: 'なんばマルイ',
				place	: '大阪府大阪市中央区難波3-8-9',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3281.567838777253!2d135.49880741561344!3d34.66561548044352!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6000e76cbb24030b%3A0xbf71c46526fcebc0!2z44Gq44KT44Gw44Oe44Or44Kk!5e0!3m2!1sja!2sjp!4v1528425337536',
				lat		: 34.665615,
				lng		: 135.500996,
				zoom	: 16,
			},
			parking : [
				{
					name	: '大昌タワーパーキング',
					place	: '大阪府大阪市中央区千日前2丁目8-1',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3281.541756902833!2d135.50182731561355!3d34.66627398044351!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6000e76ae20344e1%3A0x465f9e4fcc5026ef!2z5aSn5piM44K_44Ov44O844OR44O844Kt44Oz44Kw!5e0!3m2!1sja!2sjp!4v1528425359712',
					lat 	: 34.666274,
					lng		: 135.504016,
					zoom	: 16,
				},
				{
					name	: 'タイムズなんばウォークパーキング',
					place	: '大阪府大阪市浪速区湊町1丁目1',
					url		: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d820.3708367723476!2d135.4959143086958!3d34.667748637756084!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6000e7120c9a3763%3A0xa2539471fa343856!2z44CSNTU2LTAwMTcg5aSn6Ziq5bqc5aSn6Ziq5biC5rWq6YCf5Yy65rmK55S677yR5LiB55uu77yR4oiS77yS77ySIOOCv-OCpOODoOOCuuOBquOCk-OBsOOCpuOCqeODvOOCr-ODkeODvOOCreODs-OCsA!5e0!3m2!1sja!2sjp!4v1531971840513',
					lat 	: 34.667985,
					lng		: 135.497185,
					zoom	: 15,
				},
				{
					name	: 'タイムズ難波中央パーキング',
					place	: '大阪府大阪市浪速区難波中2-11',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3281.7946476502943!2d135.50006511561335!3d34.659888680444936!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6000e768d47c0781%3A0x16d9b3cde190c59e!2z44K_44Kk44Og44K6IOmbo-azouS4reWkrg!5e0!3m2!1sja!2sjp!4v1528425702842',
					lat 	: 34.659889,
					lng		: 135.502254,
					zoom	: 15,
				},
				{
					name	: 'タイムズ大阪難波パーキング',
					place	: '大阪府大阪市浪速区難波中2-5',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3281.7094179662317!2d135.50230231561332!3d34.662040780444364!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6000e769a4e04635%3A0x53858174e2dc0780!2z44K_44Kk44Og44K65aSn6Ziq6Zuj5rOi!5e0!3m2!1sja!2sjp!4v1528425726025',
					lat 	: 34.662041,
					lng		: 135.504491,
					zoom	: 15,
				},
			]
		},
		'083' : {
			marui : {
				name	: '神戸マルイ',
				place	: '兵庫県神戸市中央区三宮町1-7-2',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3280.5041470237456!2d135.19192541561407!3d34.692462080436655!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60008efad9ca9955%3A0x2e604d66be27a7f4!2z56We5oi444Oe44Or44Kk!5e0!3m2!1sja!2sjp!4v1528425838154',
				lat		: 34.692463,
				lng		: 135.194115,
				zoom	: 16,
			},
			parking : [
				{
					name	: '神戸サンセンタープラザ駐車場',
					place	: '兵庫県神戸市中央区三宮町1-9-1',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3280.5347049360576!2d135.190061715614!3d34.69169108043676!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60008efb456f5a51%3A0xcb3e6443d8160177!2z44CSNjUwLTAwMjEg5YW15bqr55yM56We5oi45biC5Lit5aSu5Yy65LiJ5a6u55S677yR5LiB55uu77yZ4oiS77yR!5e0!3m2!1sja!2sjp!4v1528425880392',
					lat 	: 34.691117,
					lng		: 135.191167,
					zoom	: 16,
				},
				{
					name	: '神戸市立三宮駐車場（北）',
					place	: '兵庫県神戸市中央区加納町6丁目5',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3280.6200221775784!2d135.1931468656138!3d34.6895383804373!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60008efa4202b4e9%3A0x2dd7aa0d165c475d!2z56We5oi45biC56uL5LiJ5a6u6aeQ6LuK5aC0KOWMlyk!5e0!3m2!1sja!2sjp!4v1528425932172',
					lat 	: 34.690538,
					lng		: 135.195048,
					zoom	: 16,
				},
			]
		},
		'060' : {
			marui : {
				name	: '戸塚モディ',
				place	: '神奈川県横浜市戸塚区戸塚町10',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3252.1523939083636!2d139.53241031562987!3d35.4014729802605!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60185a84ebbc8c07%3A0x58015ce9807a9534!2z5oi45aGa44Oi44OH44Kj!5e0!3m2!1sja!2sjp!4v1528417865828',
				lat		: 35.401473,
				lng		: 139.534600,
				zoom	: 17,
			},
			parking : [
				{
					name	: '戸塚モディタワー駐車場',
					place	: '神奈川県横浜市戸塚区戸塚町10',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3252.14541507808!2d139.53242031562982!3d35.40164598026044!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60185a84ef754a9d%3A0xdb5d5c1293509a10!2z5oi45aGa44Oi44OH44KjIOOCv-ODr-ODvOmnkOi7iuWgtA!5e0!3m2!1sja!2sjp!4v1528418070064',
					lat		: 35.401646,
					lng		: 139.534609,
					zoom	: 17,
				},
				{
					name	: '戸塚町24H有料駐車場',
					place	: '神奈川県横浜市戸塚区戸塚町1-1',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d966.8688616899844!2d139.5350964740922!3d35.40162554938907!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60185a8521b7f0b9%3A0xba9606ffc5736620!2z5oi45aGa55S6MjRo5pyJ5paZ6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1678677744970!5m2!1sja!2sjp',
					lat 	: 35.401604,
					lng		: 139.535835,
					zoom	: 17,
				},
				{
					name	: 'NRK戸塚駅前パーキング',
					place	: '神奈川県横浜市戸塚区戸塚町1',
					url		: 'https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d3252.142603075376!2d139.53550883467102!3d35.40171568750318!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzXCsDI0JzA1LjgiTiAxMznCsDMyJzA4LjgiRQ!5e0!3m2!1sja!2sus!4v1678518566067!5m2!1sja!2sus',
					lat 	: 35.4017157,
					lng		: 139.5355088,
					zoom	: 17,
				},
				{
					name	: '戸塚東口駐車場',
					place	: '神奈川県横浜市戸塚区吉田町81',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d836.8669586616802!2d139.53660983478292!3d35.400988301081!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x27e27adb5b1904a2!2z5oi45aGa5p2x5Y-j6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1528418261065',
					lat 	: 35.401056,
					lng		: 139.536547,
					zoom	: 17,
				},
			]
		},
		'090' : {
			marui : {
				name	: '博多マルイ',
				place	: '福岡県福岡市博多区博多駅中央街9番1号',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3323.634259658636!2d130.41702951559017!3d33.5888441807346!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x354191b86f494bbd%3A0x337c2d29b0bd8c04!2z5Y2a5aSa44Oe44Or44Kk!5e0!3m2!1sja!2sjp!4v1528430334494',
				lat		: 33.588845,
				lng		: 130.419218,
				zoom	: 16,
			},
			parking : [
				{
					name	: 'KITTE博多・JR博多シティ駐車場',
					place	: '福岡市博多区博多駅中央街9-1',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3323.631805653274!2d130.41723651558988!3d33.588907880734624!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x354191b86ef5d34d%3A0x7b1123d967e2bbb0!2z44CSODEyLTAwMTIg56aP5bKh55yM56aP5bKh5biC5Y2a5aSa5Yy65Y2a5aSa6aeF5Lit5aSu6KGX77yZ4oiS77yR!5e0!3m2!1sja!2sjp!4v1528430382214',
					lat 	: 33.588704,
					lng		: 130.419652,
					zoom	: 16,
				},
				{
					name	: '博多駅中央駐車場',
					place	: '福岡県福岡市博多区博多駅中央街7−8',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3323.659939788543!2d130.4175626155898!3d33.58817758073467!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x354191c876209f25%3A0xebb32832585e0890!2z5Y2a5aSa6aeF5Lit5aSu6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1528430409608',
					lat 	: 33.588177,
					lng		: 130.419751,
					zoom	: 16,
				},
				{
					name	: '紙与パーキング駅三',
					place	: '福岡県福岡市博多区博多駅前3丁目26−1',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3323.6094574499434!2d130.41435031559007!3d33.5894879807345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x354191b8c85f20c3%3A0xb8a229ce605ce100!2z57SZ5LiO44OR44O844Kt44Oz44Kw6aeF5LiJ!5e0!3m2!1sja!2sjp!4v1528430426625',
					lat 	: 33.589489,
					lng		: 130.416541,
					zoom	: 16,
				},
			]
		},
		'722' : {
			marui : {
				name	: '柏モディ',
				place	: '千葉県柏市柏1-2-26',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3233.5321469116557!2d139.96840121564028!3d35.86047398015288!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60189ce77217a7cd%3A0x23a1fe71ea6c5e3e!2z5p-P44Oi44OH44Kj!5e0!3m2!1sja!2sjp!4v1528424254793',
				lat 	: 35.860473,
				lng		: 139.970590,
				zoom	: 17,
			},
			parking : [
				{
					name	: 'タイムズ柏モディ（柏モディ地下）',
					place	: '千葉県柏市柏１丁目２−２',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3233.534144976925!2d139.97025!3d35.860425!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60189d790a08ae93%3A0x77d2a3de47543fcd!2z44K_44Kk44Og44K65p-P44Oi44OH44Kj!5e0!3m2!1sja!2sjp!4v1779091919131!5m2!1sja!2sjp',
					lat 	: 35.860425,
					lng		: 139.97025,
					zoom	: 17,
				},
				{
					name	: 'タイムズ24柏中央町駐車場',
					place	: '千葉県柏市中央町3-3',
					url		: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6467.112264889477!2d139.969542!3d35.859886!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x5cdfe952faca2351!2z44K_44Kk44Og44K65p-P5Lit5aSu55S6!5e0!3m2!1sja!2sus!4v1527753770520',
					lat 	: 35.859886,
					lng		: 139.969542,
					zoom	: 16,
				},
				{
					name	: 'タイムズ柏市 市営駐車場',
					place	: '千葉県柏市中央町１−１',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3233.5762023881725!2d139.97252799999998!3d35.859394!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60189cdde3945bf5%3A0xf9012dfe54f14a03!2z5p-P5biC5biC5Za26aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1779092020240!5m2!1sja!2sjp',
					lat 	: 35.859394,
					lng		: 139.972528,
					zoom	: 16,
				},
				{
					name	: '東葉駐車場',
					place	: '千葉県柏市末広町5-19',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3233.5179833874818!2d139.9704154156403!3d35.860821180152826!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60189ce5ddc01dd3%3A0xe74d04bd536c455a!2z5p2x6JGJ56uL5L2T6aeQ6LuK5aC077yI6Ieq6LWw5byP77yJ!5e0!3m2!1sja!2sjp!4v1528424206938',
					lat 	: 35.863810,
					lng		: 139.968817,
					zoom	: 16,
				},
			]
		},
		'723' : {
			marui : {
				name	: '町田モディ',
				place	: '東京都町田市原町田6-2-6',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3246.422677016099!2d139.44299331557335!3d35.543261980226745!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018feb366feb251%3A0x6e4782cdba954f8f!2z55S655Sw44Oi44OH44Kj!5e0!3m2!1sja!2sjp!4v1528367737544',
				lat		: 35.543262,
				lng		: 139.445183,
				zoom	: 17,
			},
			parking : [
				{
					name	: 'アミックスパーキング',
					place	: '東京都町田市原町田6丁目18-16',
					url		: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1623.1880818404031!2d139.447377!3d35.544411!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f942f6c878bb%3A0x42ce9e736fa477e1!2z44Ki44Of44OD44Kv44K544OR44O844Kt44Oz44Kw!5e0!3m2!1sja!2sjp!4v1767004899017!5m2!1sja!2sjp',
					lat 	: 35.544411,
					lng		: 139.447377,
					zoom	: 16,
				},
				{
					name	: '市営原町田一丁目駐車場',
					place	: '東京都町田市原町田1-6-21',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3246.53634184212!2d139.44547231557345!3d35.540453980227376!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f94abf6cfad7%3A0xd6046b07da659d41!2z5biC5Za25Y6f55S655Sw77yR5LiB55uu6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1528364537141',
					lat 	: 35.540454,
					lng		: 139.447661,
					zoom	: 16,
				},
				{
					name	: 'ぽっぽ町田パーキング',
					place	: '東京都町田市原町田4-10-20',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3246.4594408304265!2d139.44686241557352!3d35.542353780227025!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f94b007a3f4d%3A0x9016d44507bd00f1!2z44CSMTk0LTAwMTMg5p2x5Lqs6YO955S655Sw5biC5Y6f55S655Sw77yU5LiB55uu77yR77yQ4oiS77yS77yQ!5e0!3m2!1sja!2sjp!4v1528364617951',
					lat 	: 35.542434,
					lng		: 139.449189,
					zoom	: 16,
				},
				{
					name	: 'パークワン（モディ提携）',
					place	: '東京都町田市森野1-24',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3246.3336179297257!2d139.44082231557363!3d35.54546198022611!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018feb241c3e789%3A0xa6b26b773509bb64!2z44OR44O844Kv44Ov44Oz44Oe44OB44OAIOmnkOi7iuWgtA!5e0!3m2!1sja!2sjp!4v1528364772070',
					lat 	: 35.545460,
					lng		: 139.443012,
					zoom	: 16,
				},
				{
					name	: 'アイパーク駐車場　町田森野第1',
					place	: '東京都町田市森野1丁目24-13',
					url		: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3246.3421022375614!2d139.4430065!3d35.5452524!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018ff007158ef11%3A0xa9b478f43ac95918!2z44Ki44Kk44OR44O844Kv6aeQ6LuK5aC055S655Sw5qOu6YeO56ysMQ!5e0!3m2!1sja!2sjp!4v1767005418018!5m2!1sja!2sjp',
					lat 	: 35.5452524,
					lng		: 139.4430065,
					zoom	: 16,
				},
			]
		},
		'724' : {
			marui : {
				name	: '静岡モディ',
				place	: '静岡県静岡市葵区御幸町6-10',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3269.3121094953344!2d138.38498391562035!3d34.973846180365264!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601a49f7bb7b4c1f%3A0xf729c9c037572fe0!2zTU9ESSDpnZnlsqHjg6Ljg4fjgqM!5e0!3m2!1sja!2sjp!4v1528427032817',
				lat		: 34.973869,
				lng		: 138.387237,
				zoom	: 16,
			},
			parking : [
				{
					name	: 'しまのパーキング',
					place	: '静岡県静岡市葵区伝馬8-1',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3269.268808878258!2d138.38492831562021!3d34.974930980365!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601a49f7dadfe9f5%3A0x655a395943bf99d5!2z44GX44G-44Gu44OR44O844Kt44Oz44Kw!5e0!3m2!1sja!2sjp!4v1528426845088',
					lat 	: 34.974931,
					lng		: 138.387118,
					zoom	: 17,
				},
				{
					name	: 'しまの第2パーキング',
					place	: '静岡県静岡市葵区御幸町7-15',
					url		: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1943.938084320454!2d138.3853505110457!3d34.974121170634085!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x4ab27f0e97e5f461!2z44GX44G-44Gu45Cn77yS44OR44O844Kt44Oz44Kw!5e0!3m2!1sja!2sjp!4v1634283029011!5m2!1sja!2sjp',
					lat 	: 34.9741212,
					lng		: 138.3853505,
					zoom	: 17,
				},
				{
					name	: '伝馬町パーキング',
					place	: '静岡県静岡市葵区伝馬町11-1',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3269.299208844083!2d138.38637621562034!3d34.97416938036519!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601a49f787d23079%3A0xb15784f267b9a87c!2z5Lyd6aas55S644OR44O844Kt44Oz44Kw!5e0!3m2!1sja!2sjp!4v1528426863041',
					lat 	: 34.974169,
					lng		: 138.388566,
					zoom	: 17,
				},
				{
					name	: '関川パーキング',
					place	: '静岡県静岡市葵区伝馬町10-4',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3269.270760784176!2d138.38639531562035!3d34.974882080364964!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601a49f78ca4670d%3A0xf9127167c387ab80!2z6Zai5bed44OR44O844Kt44Oz44Kw!5e0!3m2!1sja!2sjp!4v1528426882288',
					lat 	: 34.974881,
					lng		: 138.388585,
					zoom	: 17,
				},
				{
					name	: 'パークワン静岡',
					place	: '静岡県静岡市葵区伝馬町11-25',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3269.283382253284!2d138.3868426156204!3d34.97456588036514!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601a49f82637d2ed%3A0x2d79b3a0586aa1bc!2z44OR44O844Kv44Ov44Oz6Z2Z5bKh!5e0!3m2!1sja!2sjp!4v1528426902936',
					lat 	: 34.974566,
					lng		: 138.389030,
					zoom	: 17,
				},
				{
					name	: '新静岡セノバ駐車場',
					place	: '静岡県静岡市葵区鷹匠1丁目1-1',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3269.2265489325455!2d138.38573061523962!3d34.97598968036488!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601a49397bd0453d%3A0x8d45961996c93b5b!2z5paw6Z2Z5bKh44K744OO44OQ6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1627885252796!5m2!1sja!2sjp',
					lat 	: 34.97585,
					lng		: 138.3884,
					zoom	: 16,
				},
				{
					name	: 'エキパ駐車場',
					place	: '静岡県静岡市葵区黒金町1-1',
					url		: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d5498.401194312977!2d138.38664482340042!3d34.97242310864716!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x2b58787aaf44b37!2z6Z2Z5bKh6aeF5YyX5Y-j5Zyw5LiL6aeQ6LuK5aC077yI44Ko44Kt44OR77yJ!5e0!3m2!1sja!2sjp!4v1627884754442!5m2!1sja!2sjp',
					lat 	: 34.9721174,
					lng		: 138.387192,
					zoom	: 16,
				},
				{
					name	: 'NPD松坂屋前パーキング',
					place	: '静岡県静岡市葵区御幸町11-1',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3269.321441646645!2d138.38666921523964!3d34.97361238036539!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601a49f77e1878cd%3A0xa9bd4723be7b10da!2z44CSNDIwLTA4NTcg6Z2Z5bKh55yM6Z2Z5bKh5biC6JG15Yy65b6h5bm455S6IO-8ru-8sO-8pOadvuWdguWxi-WJjeODkeODvOOCreODs-OCsA!5e0!3m2!1sja!2sjp!4v1627884852793!5m2!1sja!2sjp',
					lat 	: 34.973612,
					lng		: 138.388858,
					zoom	: 16,
				},
				{
					name	: '稲森パーキング 本社',
					place	: '静岡県静岡市葵区紺屋町17-2',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3269.3679611045695!2d138.38606009999998!3d34.9724469!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601a49f6fc357e2d%3A0x9addd63c8991e752!2z56iy5qOu44OR44O844Kt44Oz44Kw5pys56S-!5e0!3m2!1sja!2sjp!4v1779090938017!5m2!1sja!2sjp',
					lat 	: 34.9724469,
					lng		: 138.3860601,
					zoom	: 16,
				},
				{
					name	: '稲森パーキング 7号',
					place	: '静岡県静岡市葵区紺屋町11-7',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3269.390196942979!2d138.38469!3d34.97188980000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601a49f68c1c8f33%3A0xeb79435512cfc4fa!2z56iy5qOu44OR44O844Kt44Oz44Kw77yX5Y-3!5e0!3m2!1sja!2sjp!4v1779091595445!5m2!1sja!2sjp',
					lat 	: 34.9718898,
					lng		: 138.38469,
					zoom	: 16,
				},
				{
					name	: '稲森パーキング 8号',
					place	: '静岡県静岡市葵区紺屋町15-5',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3269.4084731258467!2d138.38439259999998!3d34.97143189999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601a49f69020718b%3A0xa4671dc03927d263!2z56iy5qOu44OR44O844Kt44Oz44Kw77yY5Y-3!5e0!3m2!1sja!2sjp!4v1779091715690!5m2!1sja!2sjp',
					lat 	: 34.9714319,
					lng		: 138.3843926,
					zoom	: 16,
				},

			]
		},
		'721' : {
			marui : {
				name	: '渋谷モディ',
				place	: '東京都渋谷区神南1-21-3',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1146.0877696942885!2d139.69998563850282!3d35.66159164009948!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188ca80c832a73%3A0x1d9e522f0d370fb1!2z5riL6LC344Oi44OH44Kj!5e0!3m2!1sja!2sjp!4v1528363348317',
				lat		: 35.661513,
				lng		: 139.700501,
				zoom	: 16,
			},
			parking : [
				{
					name	: '渋谷区役所前公共駐車場',
					place	: '東京都渋谷区宇田川町1-1',
					url		: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12966.158413719366!2d139.6991168!3d35.6637132!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x73879bb42139f0ae!2z5riL6LC35Yy65b255omA5YmN5YWs5YWx6aeQ6LuK5aC0!5e0!3m2!1sja!2sjp!4v1626341939069!5m2!1sja!2sjp',
					lat 	: 35.664536,
					lng		: 139.698570,
					zoom	: 15,
				},
				{
					name	: '渋谷マルイ・渋谷モディ駐車場',
					place	: '東京都渋谷区神南1丁目１２番２０号',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.5906896038396!2d139.69825941563582!3d35.66245488019854!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188ca88e139225%3A0xbef8bf8e792e1b13!2z44CSMTUwLTAwNDEg5p2x5Lqs6YO95riL6LC35Yy656We5Y2X77yR5LiB55uu77yR77yS4oiS77yS77yQ!5e0!3m2!1sja!2sjp!4v1528444565532',
					lat 	: 35.664536,
					lng		: 139.698570,
					zoom	: 15,
				},
			]
		},
		'726' : {
			marui : {
				name	: '川越モディ',
				place	: '埼玉県川越市脇田町4-2',
				url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3231.5478125514555!2d139.4807332156414!3d35.909088980141775!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018da573a41865d%3A0x4e34d1031702d8!2z5bed6LaK44Oi44OH44Kj!5e0!3m2!1sja!2sjp!4v1528419926169',
				lat		: 35.909089,
				lng		: 139.482922,
				zoom	: 16,
			},
			parking : [
				{
					name	: 'ParkOne24',
					place	: '川越市脇田町4-10',
					lat		: 35.908897,
					lng		: 139.482605,
					zoom	: 17,
				},
				{
					name	: 'タイムズ24',
					place	: '埼玉県川越市脇田町４−２',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3231.547812551456!2d139.4807332156413!3d35.90908898014177!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018da573a41865d%3A0x926f643623976f8b!2z44CSMzUwLTExMjIg5Z-8546J55yM5bed6LaK5biC6ISH55Sw55S677yU4oiS77yS!5e0!3m2!1sja!2sjp!4v1528444780899',
					lat		: 35.909089,
					lng		: 139.482922,
					zoom	: 17,
				},
				{
					name	: 'タイムズ川越モディ駐車場',
					place	: '川越市脇田町4-2',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3231.5478125514555!2d139.4807332156414!3d35.909088980141775!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018da573a41865d%3A0x4e34d1031702d8!2z5bed6LaK44Oi44OH44Kj!5e0!3m2!1sja!2sjp!4v1528420950330',
					lat		: 35.909089,
					lng		: 139.482922,
				},
				{
					name	: 'タイムズ脇田町第5駐車場',
					url		: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3231.5478125514555!2d139.4807332156414!3d35.909088980141775!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018da50b1a6a385%3A0x138dc94b318be14f!2z44K_44Kk44Og44K6IOW3nei2iuiEh-eUsOeUuuesrDU!5e0!3m2!1sja!2sjp!4v1528420984354',
					lat		: 35.909503,
					lng		: 139.481964,
				},

			]
		},
	};

	STORE.CONS.PARKING_IMG_LIST = {
		'003' : [
			{
				parkingName : 'ParkOne新宿マルイメン駐車場',
				parkingImg  : '/assets/img/074/access/men-irasuto.jpg'
			}
		],
		'005' : [
			{
				parkingName : 'ParkOne新宿マルイメン駐車場',
				parkingImg  : '/assets/img/074/access/men-irasuto.jpg'
			}
		],
		'074' : [
			{
				parkingName : 'ParkOne新宿マルイメン駐車場',
				parkingImg  : '/assets/img/074/access/men-irasuto.jpg'
			}
		]

	}

  STORE.CONS.DECISION_PAGE_TYPE = {
		'top'			: [/^\/$/, /^\/index\.html$/],
		'store-top'		: [/^\/\d{3}\/$/, /^\/\d{3}\/index.html$/],
	};

  /**
	 * 店舗ニュース 集中表記削除条件
	 */
	STORE.CONS.STORE_NEWS_DELETE_NOTE = {
		'048' : [
			'37734'
		],
		'054' : [
			'37683',
			'37802'
		],
		'001' : [
			'37716'
		],
		'016' : [
			'37732'
		],
		'052' : [
			'37733'
		],
		'723' : [
			'37704'
		],
		'083' : [
			'37714'
		],
		'058' : [
			{
				seq  : '37730',
				type : 'sto',
			}
		],
	};

  /** お店からのお知らせソート用 */
	STORE.CONS.ALL_STORE_ARTICLE_VIEW = '00';
	STORE.CONS.STORE_ARTICLE_TYPE_FOR_SORT = {
		'00'	: 1,
		'01'	: 2,
		'02'	: 3,
		'03'	: 4,
	};

  /** お店からお知らせ 特集 事区分 */
	STORE.CONS.STORE_FEATURE_ARTICLE_TYPE_SHOP		= '01' //ショップ記事
	STORE.CONS.STORE_FEATURE_ARTICLE_TYPE_STORE	= '02' //店舗記事

  /** 2021トライアル 店舗ニュースディレクトリ */
	STORE.CONS.STORE_NEWS_TYPE_DIR = {
		'01' : 'event',
		'02' : 'news'
	};

  /** 特集静的記事の挿入 */
	STORE.CONS.FEATURE_PAGE_TYPE = [
		'featureList', 'featureDetail'
	];
	STORE.CONS.STATIC_FEATURE_ATTICLES = {
		'086' : [
			// {
			// 	isStatic    : true,
			// 	staticLink  : 'https://www.youtube.com/watch?v=JDcwOcQq6yc',
			// 	imgPath     : '/assets/img/stores/movie/movie_211202.jpg',
			// 	title       : '誰もがお買い物が楽しめるサービス「Marui Mobility Service」',
			// 	update      : 20211202235959,
			// 	dispUpdate  : '21.12.2',
			// 	linkType    : '_blank',
			// },
			// {
			// 	isStatic    : true,
			// 	staticLink  : 'https://youtu.be/Qwwr-SArUAI',
			// 	imgPath     : '/assets/img/stores/column/086/bnr_20220906b.jpg',
			// 	title       : 'インクルージョンフェス2022AUTUMN in 有楽町マルイ SPECIAL MOVIE 第3弾',
			// 	update      : 20220906235959,
			// 	dispUpdate  : '22.9.6',
			// 	linkType    : '_blank',
			// },
			// {
			// 	isStatic    : true,
			// 	staticLink  : 'https://youtube.com/shorts/lzlbVm8vuJg',
			// 	imgPath     : '/assets/img/stores/column/086/bnr_20220906a.jpg',
			// 	title       : 'インクルージョンフェス2022AUTUMN in 有楽町マルイ SPECIAL MOVIE 第2弾',
			// 	update      : 20220906235959,
			// 	dispUpdate  : '22.9.6',
			// 	linkType    : '_blank',
			// },
			// {
			// 	isStatic    : true,
			// 	staticLink  : 'https://youtu.be/8bKgGm_8qHA',
			// 	imgPath     : '/assets/img/stores/column/086/bnr_20221020.png',
			// 	title       : 'ITOCiA × 有楽町マルイ 15th Anniversary NAKED AROMA',
			// 	update      : 20221020235959,
			// 	dispUpdate  : '22.10.20',
			// 	linkType    : '_blank',
			// },
			{
				isStatic    : true,
				staticLink  : '/086/feature/20210311/',
				imgPath     : '/assets/img/stores/column/086/bnr_cosme086.jpg',
				title       : 'Cosme &amp; Beauty Featured Shop',
				update      : 20210331235959,
				dispUpdate  : '21.3.11',
				linkType    : '_self',
			},
			{
				isStatic    : true,
				staticLink  : '/086/column/20210311/',
				imgPath     : '/assets/img/stores/column/086/bnr_column.png',
				title       : 'ひとりの時間、空を見上げて。',
				update      : 20210331235959,
				dispUpdate  : '21.3.11',
				linkType    : '_self',
			}
			// {
			// 	isStatic    : true,
			// 	staticLink  : 'https://www.youtube.com/watch?v=iG77jHute5c',
			// 	imgPath     : '/assets/img/stores/column/086/bnr_movie_firework.jpg',
			// 	title       : '[HANABI FLOWERS]7/17-8/31 Making',
			// 	update      : 20210717235959,
			// 	dispUpdate  : '21.7.17',
			// },
			// {
			// 	isStatic    : true,
			// 	staticLink  : 'https://www.youtube.com/watch?v=EaLGwW_nLqE',
			// 	imgPath     : '/assets/img/stores/column/086/bnr_movie_fit.jpg',
			// 	title       : '「すべての人」が使いやすい試着室『みんなのフィッティングルーム』',
			// 	update      : 20190806235959,
			// 	dispUpdate  : '19.8.06',
			// 	linkType    : '_blank',
			// },
			// {
			// 	isStatic    : true,
			// 	staticLink  : 'https://www.youtube.com/watch?v=T4ILiM46IY4',
			// 	imgPath     : '/assets/img/stores/feature/086/bnr_lossflower.jpg',
			// 	title       : 'The loss flower story - ロスフラワーを使用した「体感スぺース」が再登場',
			// 	update      : 20210917235959,
			// 	dispUpdate  : '21.9.17',
			// 	linkType    : '_blank',
			// },
		]
		// '058' : [
		// 	{
		// 		isStatic    : true,
		// 		staticLink  : '/058/feature/20210315/',
		// 		imgPath     : '/assets/img/058/feature/20210315/rote.jpg',
		// 		title       : '上野改装 B1F RENEWAL OPEN',
		// 		update      : 20210331235959,
		// 		dispUpdate  : '21.3.15',
		// 		linkType    : '_self',
		// 	},
		// 	{
		// 		isStatic    : true,
		// 		staticLink  : '/058/column/20210311/',
		// 		imgPath     : '/assets/img/stores/column/086/bnr_column.png',
		// 		title       : 'ひとりの時間、空を見上げて。',
		// 		update      : 20210331235959,
		// 		dispUpdate  : '21.3.11',
		// 		linkType    : '_self',
		// 	}
		// ]
	};

  /**
   * 特定の記事にのみバナーを出力
   * [Ticket No.]2015
   */
  STORE.CONS.IRREGULAR_CONSEPT_SHOP = {
    '003': [{
      'seq': '4014',
      'class': 'conseptshops-bnr',
      'bnr': 'コンセプトショップスへの出店についてはこちら',
      'link': 'https://omemie.0101.co.jp/spaces/117?building_ids=2&utm_source=corporate_site&utm_medium=referral&utm_campaign=shinjuku_honkan_cs',
      'linkType': 'text',
      'target': '_blank'
    }, {
      'seq': '4550',
      'class': 'omemie-bnr',
      'bnr': '<img src="/assets/img/common/stores/omemie_220120.jpg">',
      'link': 'https://omemie.0101.co.jp/spaces?building_ids=2&utm_source=corporate_site&utm_medium=referral&utm_campaign=shinjuku_honkan_cs',
      'linkType': 'text',
      'target': '_blank'
    }],
    '058': [{
      'seq': '4551',
      'class': 'omemie-bnr',
      'bnr': '<img src="/assets/img/common/stores/omemie_220120.jpg">',
      'link': 'https://omemie.0101.co.jp/spaces?building_ids=4&utm_source=corporate_site&utm_medium=referral&utm_campaign=ueno_cs',
      'linkType': 'text',
      'target': '_blank'
    }]
  };

	STORE.CONS.ANALYTICS_PAGE_NAMES = {
		'/' : 'storeTop',
		'/info/' : 'storeInfo',
		'/info/tel.html' : 'storeInfoTel',
		'/access/' : 'storeAccess',
		'/food/' : 'restaurant',
		'/facility/' : 'facilityInfo',
		'/event/' : 'storeEvent',
		'/event/detail.html' : 'storeEventDetail',
		'/feature/' : 'featureList',
		'/feature/detail.html' : 'featureDetail',
		'/recommend/' : 'recommendList',
		'/recommend/detail.html' : 'recommendDetail',
		'/sale-campaign/' : 'saleCampaignList',
		'/sale-campaign/detail.html' : 'saleCampaignDetail',
		'/mail/' : 'mailList',
		'/mail/detail.html' : 'mailDetail',
		'/news/' : 'newsList',
		'/news/detail.html' : 'newsDetail',
		'/shop-mail/' : 'shopMail',
		'/shopsearch/' : 'shopSearch',
		'/shopsearch/result.html' : 'shopSearchResult',
		'/shop-guide/shop-detail.html' : 'shopDetail'
	};

	STORE.CONS.PAGE_TYPE2PARAM = {
		'storeTop' : 'top',
		'storeInfo' : 'info',
		'storeInfoTel' : 'info-tel',
		'storeAccess' : 'access',
		'restaurant' : 'food',
		'facilityInfo' : 'facility',
		'storeEvent' : 'event-list',
		'storeEventDetail' : 'event-detail',
		'featureList' : 'feature-list',
		'featureDetail' : 'feature-detail',
		'recommendList' : 'recommend-list',
		'recommendDetail' : 'recommend-detail',
		'saleCampaignList' : 'sale-list',
		'saleCampaignDetail' : 'sale-detail',
		'mailList' : 'mail-list',
		'mailDetail' : 'mail-detail',
		'newsList' : 'news-list',
		'newsDetail' : 'news-detail',
		'shopMail' : 'shopmail',
		'shopSearch' : 'shopsearch-cond',
		'shopSearchResult' : 'shopsearch-result',
		'shopDetail' : 'shop-detail',
	};

	/** GoogleAnalytice TrackingCode */
	STORE.CONS.ANALYZE_TTS_TRACKING_CODE_MASTER = {
		debug	: 'UA-68447671-1',
		main	: 'UA-240618590-1',
	};
	STORE.CONS.ANALYZE_TTS_TRACKING_CODE_STORE = {
		'052' : 'UA-75075781-1',
		'090' : 'UA-76286747-1',
		'086' : 'UA-76562703-1',
		'003' : 'UA-76559116-1',
		'005' : 'UA-76558634-1',
		'074' : 'UA-76563602-1',
		'013' : 'UA-76560229-1',
		'058' : 'UA-76598613-1',
		'054' : 'UA-76621211-1',
		'016' : 'UA-76602015-1',
		'062' : 'UA-76628314-1',
		'077' : 'UA-76630616-1',
		'082' : 'UA-76603318-1',
		'076' : 'UA-76864759-1',
		'088' : 'UA-76621228-1',
		'036' : 'UA-76609030-1',
		'048' : 'UA-76624028-1',
		'084' : 'UA-76606226-1',
		'001' : 'UA-76624922-1',
		// '061' : 'UA-76625237-1',
		'078' : 'UA-76607837-1',
		'053' : 'UA-76625242-1',
		'079' : 'UA-76625635-1',
		'066' : 'UA-76597337-1',
		'085' : 'UA-76608852-1',
		'083' : 'UA-76603048-1',
		// '041' : 'UA-76628555-1',
		'060' : 'UA-79682314-1',
		'201' : 'UA-80174332-1',
		'202' : 'UA-80168540-1',
		'722' : 'UA-83847859-1',
		'723' : 'UA-100685038-1',
		'724' : 'UA-86960294-1',
		'721' : 'UA-116040655-1',
		'726' : 'UA-116052460-1',
	};

	/** デジタルチラシ番号 */
	STORE.CONS.STORE_CHIRASHI_NUMBER = {
		'001' : '6867' ,
		'052' : '6870' ,
		'086' : '6856' ,
		'003' : '6857' ,
		'005' : '6859' ,
		'074' : '6860' ,
		'013' : '6862' ,
		'058' : '6864' ,
		'054' : '6866' ,
		'016' : '6868' ,
		'062' : '6869' ,
		'077' : '6871' ,
		'082' : '6874' ,
		'076' : '6878' ,
		'088' : '6882' ,
		'036' : '6881' ,
		'048' : '6863' ,
		'084' : '6865' ,
		'001' : '6867' ,
		// '061' : '6872' ,
		'078' : '6873' ,
		'053' : '6875' ,
		'079' : '6876' ,
		'066' : '6877' ,
		'085' : '6883' ,
		'083' : '6884' ,
		// '041' : '6880' ,
		'060' : '8264' ,
		'090' : '32082' ,
	};

	/** クローズド化対象記事 */
	STORE.CONS.CLOSED_ARTICLE_LIST = {
		'086' : [
			{
				seq: '3786',
				type: 'cam'
			},
			{
				seq: '4006',
				type: 'cam'
			},
			{
				seq: '4434',
				type: 'cam'
			},
			{
				seq: '4436',
				type: 'cam'
			},
		],
		'003' : [
			{
				seq: '3801',
				type: 'cam'
			},
			{
				seq: '4024',
				type: 'cam'
			},
			{
				seq: '4408',
				type: 'cam'
			},
			{
				seq: '4437',
				type: 'cam'
			},
		],
		'005' : [
			{
				seq: '3802',
				type: 'cam'
			},
			{
				seq: '4025',
				type: 'cam'
			},
			{
				seq: '4409',
				type: 'cam'
			},
			{
				seq: '4438',
				type: 'cam'
			},
		],
		'074' : [
			{
				seq: '3803',
				type: 'cam'
			},
			{
				seq: '4026',
				type: 'cam'
			},
			{
				seq: '4418',
				type: 'cam'
			},
			{
				seq: '4439',
				type: 'cam'
			},
		],
		'058' : [
			{
				seq: '3800',
				type: 'cam'
			},
			{
				seq: '4011',
				type: 'cam'
			},
			{
				seq: '4414',
				type: 'cam'
			},
			{
				seq: '4440',
				type: 'cam'
			},
		],
		'084' : [
			{
				seq: '3794',
				type: 'cam'
			},
			{
				seq: '4016',
				type: 'cam'
			},
			{
				seq: '4423',
				type: 'cam'
			},
			{
				seq: '4441',
				type: 'cam'
			},
		],
		'054' : [
			{
				seq: '3805',
				type: 'cam'
			},
			{
				seq: '4022',
				type: 'cam'
			},
			{
				seq: '4413',
				type: 'cam'
			},
			{
				seq: '4442',
				type: 'cam'
			},
		],
		'001' : [
			{
				seq: '3789',
				type: 'cam'
			},
			{
				seq: '4023',
				type: 'cam'
			},
			{
				seq: '4407',
				type: 'cam'
			},
			{
				seq: '4443',
				type: 'cam'
			},
		],
		'016' : [
			{
				seq: '3797',
				type: 'cam'
			},
			{
				seq: '4017',
				type: 'cam'
			},
			{
				seq: '4410',
				type: 'cam'
			},
			{
				seq: '4444',
				type: 'cam'
			},
		],
		'062' : [
			{
				seq: '3793',
				type: 'cam'
			},
			{
				seq: '4007',
				type: 'cam'
			},
			{
				seq: '4416',
				type: 'cam'
			},
			{
				seq: '4445',
				type: 'cam'
			},
		],
		'052' : [
			{
				seq: '3799',
				type: 'cam'
			},
			{
				seq: '4009',
				type: 'cam'
			},
			{
				seq: '4411',
				type: 'cam'
			},
			{
				seq: '4446',
				type: 'cam'
			},
		],
		'723' : [
			{
				seq: '3798',
				type: 'cam'
			},
			{
				seq: '4008',
				type: 'cam'
			},
			{
				seq: '4429',
				type: 'cam'
			},
			{
				seq: '4447',
				type: 'cam'
			},
		],
		'078' : [
			{
				seq: '3795',
				type: 'cam'
			},
			{
				seq: '4003',
				type: 'cam'
			},
			{
				seq: '4419',
				type: 'cam'
			},
			{
				seq: '4448',
				type: 'cam'
			},
		],
		'082' : [
			{
				seq: '3796',
				type: 'cam'
			},
			{
				seq: '4030',
				type: 'cam'
			},
			{
				seq: '4421',
				type: 'cam'
			},
			{
				seq: '4449',
				type: 'cam'
			},
		],
		'060' : [
			{
				seq: '3790',
				type: 'cam'
			},
			{
				seq: '4031',
				type: 'cam'
			},
			{
				seq: '4415',
				type: 'cam'
			},
			{
				seq: '4450',
				type: 'cam'
			},
		],
		'053' : [
			{
				seq: '3792',
				type: 'cam'
			},
			{
				seq: '4010',
				type: 'cam'
			},
			{
				seq: '4412',
				type: 'cam'
			},
			{
				seq: '4451',
				type: 'cam'
			},
		],
		'079' : [
			{
				seq: '3781',
				type: 'cam'
			},
			{
				seq: '4001',
				type: 'cam'
			},
			{
				seq: '4420',
				type: 'cam'
			},
			{
				seq: '4452',
				type: 'cam'
			},
		],
		'066' : [
			{
				seq: '3779',
				type: 'cam'
			},
			{
				seq: '4020',
				type: 'cam'
			},
			{
				seq: '4417',
				type: 'cam'
			},
			{
				seq: '4453',
				type: 'cam'
			},
		],
		'722' : [
			{
				seq: '3788',
				type: 'cam'
			},
			{
				seq: '4005',
				type: 'cam'
			},
			{
				seq: '4428',
				type: 'cam'
			},
			{
				seq: '4454',
				type: 'cam'
			},
		],
		'085' : [
			{
				seq: '3763',
				type: 'cam'
			},
			{
				seq: '4002',
				type: 'cam'
			},
			{
				seq: '4424',
				type: 'cam'
			},
			{
				seq: '4455',
				type: 'cam'
			},
		],
		'083' : [
			{
				seq: '3804',
				type: 'cam'
			},
			{
				seq: '4027',
				type: 'cam'
			},
			{
				seq: '4422',
				type: 'cam'
			},
			{
				seq: '4456',
				type: 'cam'
			},
		],
		'090' : [
			{
				seq: '118517',
				type: 'sto'
			},
			{
				seq: '4014',
				type: 'cam'
			},
			{
				seq: '4426',
				type: 'cam'
			},
			{
				seq: '4457',
				type: 'cam'
			},
		],
		'721' : [
			{
				seq: '4427',
				type: 'cam'
			},
			{
				seq: '4460',
				type: 'cam'
			},
		],
		'724' : [
			{
				seq: '4430',
				type: 'cam'
			},
			{
				seq: '4430',
				type: 'cam'
			},
			{
				seq: '4458',
				type: 'cam'
			},
		],
	};

	/**
	 * 記事末尾（表示中SHAREの直前）へ挿入するHTML
	 * キー → HTML文字列
	 */
	STORE.CONS.APPEND_HTML_ARTICLE = {
		eposPlatinumGoldNote: `
		<div class="c-campaign-caution-html">
			<div class="c-campaign-caution-html__inner">
				<div class="c-campaign-caution-html__text">
					<h4 class="c-campaign-caution-html__title">ご利用の際の注意事項</h4>
					<ul class="c-campaign-caution-html__list">
						<li class="c-campaign-caution-html__item">「エポスプラチナカード」「エポスゴールドカード」のご利用(1回・2回・分割・リボ払い・ボーナス払い)が対象となります。</li>
						<li class="c-campaign-caution-html__item">10%の割引は、エポスカードクレジットご請求額に反映いたします。</li>
						<li class="c-campaign-caution-html__item">一部対象外ショップ・商品がございます。</li>
						<li class="c-campaign-caution-html__item">マルイウェブチャネルのご利用は10%エポスポイントプレゼントとなります。</li>
						<li class="c-campaign-caution-html__item">エポスポイントおよびクーポンをご利用した場合は、割引後の金額から10%の割引となります。</li>
						<li class="c-campaign-caution-html__item">エポスポイントは、割引後のお買上げ金額に対し付与されます。</li>
					</ul>
				</div>
			</div>
		</div>
		`,
	};

	/**
	 * 記事末尾（表示中SHAREの直前）へHTMLを挿入する対象
	 * 店舗コード → { seq, type, html }
	 * html は APPEND_HTML_ARTICLE のキー
	 */
	STORE.CONS.APPEND_HTML_ARTICLE_LIST = {
		'001': [{ seq: '4407', type: 'cam', html: 'eposPlatinumGoldNote' }],
		'003': [{ seq: '4408', type: 'cam', html: 'eposPlatinumGoldNote' }],
		'005': [{ seq: '4409', type: 'cam', html: 'eposPlatinumGoldNote' }],
		'016': [{ seq: '4410', type: 'cam', html: 'eposPlatinumGoldNote' }],
		'052': [{ seq: '4411', type: 'cam', html: 'eposPlatinumGoldNote' }],
		'053': [{ seq: '4412', type: 'cam', html: 'eposPlatinumGoldNote' }],
		'054': [{ seq: '4413', type: 'cam', html: 'eposPlatinumGoldNote' }],
		'058': [{ seq: '4414', type: 'cam', html: 'eposPlatinumGoldNote' }],
		'060': [{ seq: '4415', type: 'cam', html: 'eposPlatinumGoldNote' }],
		'062': [{ seq: '4416', type: 'cam', html: 'eposPlatinumGoldNote' }],
		'066': [{ seq: '4417', type: 'cam', html: 'eposPlatinumGoldNote' }],
		'074': [{ seq: '4418', type: 'cam', html: 'eposPlatinumGoldNote' }],
		'078': [{ seq: '4419', type: 'cam', html: 'eposPlatinumGoldNote' }],
		'079': [{ seq: '4420', type: 'cam', html: 'eposPlatinumGoldNote' }],
		'082': [{ seq: '4421', type: 'cam', html: 'eposPlatinumGoldNote' }],
		'083': [{ seq: '4422', type: 'cam', html: 'eposPlatinumGoldNote' }],
		'084': [{ seq: '4423', type: 'cam', html: 'eposPlatinumGoldNote' }],
		'085': [{ seq: '4424', type: 'cam', html: 'eposPlatinumGoldNote' }],
		'086': [{ seq: '4434', type: 'cam', html: 'eposPlatinumGoldNote' }],
		'090': [{ seq: '4426', type: 'cam', html: 'eposPlatinumGoldNote' }],
		'721': [{ seq: '4427', type: 'cam', html: 'eposPlatinumGoldNote' }],
		'722': [{ seq: '4428', type: 'cam', html: 'eposPlatinumGoldNote' }],
		'723': [{ seq: '4429', type: 'cam', html: 'eposPlatinumGoldNote' }],
		'724': [{ seq: '4430', type: 'cam', html: 'eposPlatinumGoldNote' }],
	};

	/** TTS の type（st / sn / fe / ca）を article_type（sto / sho / fea / cam）に読み替える。 */
	STORE.CONS.TTS_TYPE_TO_ARTICLE_TYPE = {
		'sn': 'sho',
		'st': 'sto',
		'fe': 'fea',
		'ca': 'cam',
	};


	STORE.CONS.STORE_GA_TRACKING_IDS = {
		'052': 'G-J6MX5DRX4F',
		'090': 'G-WV5VJSHMW4',
		'086': 'G-48ZPZJ6MY4',
		'003': 'G-EGPP1VX8VW',
		'005': 'G-KDBTN84L53',
		'074': 'G-XSFBNP1V1Z',
		'013': 'G-CCE57B75TF',
		'058': 'G-GNBJB1ZD23',
		'054': 'G-2F277TQTTY',
		'016': 'G-ZKB7CXQBN8',
		'062': 'G-3ZJZ7EM6TL',
		'077': 'G-5HC25JK0LF',
		'082': 'G-X82TCQZKTR',
		'076': 'G-C2W0TBGLDW',
		'088': 'G-GSWYK6DRQF',
		'036': 'G-THDBL7X1Z1',
		'048': 'G-GB7VS3Q9MJ',
		'084': 'G-F1FJ5MBLWH',
		'001': 'G-GP2D2387VW',
		'061': 'G-S98KPZL2K1',
		'078': 'G-7SQ3N0GGEY',
		'053': 'G-VL8ZBTXKN5',
		'079': 'G-S0YCTFMN7P',
		'066': 'G-KJSG5V3264',
		'085': 'G-TPJ98RJB36',
		'083': 'G-YBRK88NB39',
		'041': 'G-055FR3C25T',
		'060': 'G-07CM92XR04',
		'201': 'G-ZHVJTB4MR4',
		'202': 'G-X9N2FNHRNJ',
		'203': 'G-KT29NWBD5N',
		'721': 'G-6H7JJVCKHT',
		'722': 'G-1LSTHSRBXG',
		'724': 'G-RSP85DJN70',
		'723': 'G-2Y21P72FHY'
	};

	STORE.CONS.STORE_GA_DIMENTION = {
		'dimension5': 'value_dimension01',
		'dimension6': 'value_dimension02',
		'dimension7': 'value_dimension03',
		'dimension8': 'value_dimension04',
		'dimension9': 'value_dimension05',
		'dimension10': 'value_dimension06',
		'dimension11': 'value_dimension07',
		'dimension12': 'value_dimension08',
		'dimension13': 'value_dimension09',
		'dimension14': 'value_dimension10',
		'dimension15': 'value_dimension11',
	};

	/** ハッシュタグ */
	STORE.CONS.HASHTAG_LIST = {
		'gourmet': '食べもの',
		'fashionz': 'ファッション・雑貨',
		'cosmehc': 'コスメ・ヘルスケア',
		'animeent': 'アニメ・エンターテインメント',
		'culture': '体験・学び',
	};

	/** FAQ */
	STORE.CONS.FAQ_ARTICLE_SEQ = {
		'001': '/001/feature/detail.html?article_seq=11374&article_type=fea',
		'003': '/003/news/detail.html?article_seq=11203&article_type=fea',
		'005': '/005/news/detail.html?article_seq=11212&article_type=fea',
		'016': '/016/feature/detail.html?article_seq=11250&article_type=fea',
		'052': '/052/news/detail.html?article_seq=11207&article_type=fea',
		'053': '/053/feature/detail.html?article_seq=11376&article_type=fea',
		'054': '/054/feature/detail.html?article_seq=3430&article_type=fea',
		'058': '/058/feature/detail.html?article_seq=11390&article_type=fea',
		'060': '/060/news/detail.html?article_seq=11392&article_type=fea',
		'062': '/062/news/detail.html?article_seq=2849&article_type=fea',
		'066': '/066/news/detail.html?article_seq=11332&article_type=fea',
		'074': '/074/news/detail.html?article_seq=11210&article_type=fea',
		'078': '/078/news/detail.html?article_seq=3421&article_type=fea',
		'079': '/079/news/detail.html?article_seq=11563&article_type=fea',
		'082': '/082/news/detail.html?article_seq=4047&article_type=fea',
		'083': '/083/feature/detail.html?article_seq=11396&article_type=fea',
		'084': '/084/news/detail.html?article_seq=11104&article_type=fea',
		'085': '/085/news/detail.html?article_seq=11565&article_type=fea',
		'086': '/086/feature/detail.html?article_seq=11074&article_type=fea',
		'090': '/090/feature/detail.html?article_seq=11394&article_type=fea',
		'721': '/721/feature/detail.html?article_seq=11381&article_type=fea',
		'722': '/722/news/detail.html?article_seq=11404&article_type=fea',
		'723': '/723/news/detail.html?article_seq=11205&article_type=fea',
		'724': '/724/news/detail.html?article_seq=11259&article_type=fea',
	};
})();
